import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { GeneralService } from 'src/app/services/general.service';
import { IGetPermissionMandatoryField, IPropertyDetails } from '../interface';
import { Subject, Subscription, forkJoin } from 'rxjs';
import { CustomerService } from 'src/app/services/operations/customer.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { ICustomerDiscounts, ICustomerMoveInSettings, ICustomerPropertyProtection, ICustomerRentRaiseSetttings, ICustomerRentalStatusList, IFacilityAllowanceItemsModel, IFacilityCustomerRentalUnitInfoModels, IPricingPromotionsList, IUnitAllowanceItemsCount } from '../models/CustomerModel';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { IFacPaymentSettingsDetails } from '../models/ProspectModel';
import { EActionTypes, EElementTypes, ELOV_LimitOptions, ELetterAndNoticesTemplates, EPropertyProtectionId, EPropertyProtectionStatus, EUserFunctions, EModuleType, EnumDiscount, EPaymentTransactionTypes, ELOV_RentalStatus } from 'src/app/Shared/enum';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { CommonMethodService } from '../common-method.service';
import { IMakePaymentCharges } from '../models/MakePaymentModel';
import { MakePaymentService } from 'src/app/services/operations/makePayment.service';
import { DataService } from 'src/app/facilityOperations/facOps-dashboard/data.service';
import { isNullOrUndefined } from 'util';
import { FingerPrintInitService } from 'src/app/services/fingerPrint/fingerPrintInit.service';
import { FingerprintpopupComponent } from 'src/app/Shared/fingerprintpopup/fingerprintpopup.component';
import { PropProtecService } from 'src/app/services/propProtec.service';
import { PropertyProtectionComponent } from '../property-protection/property-protection.component';
import { AbstractControl, FormControl, NgForm, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';

@Component({
    selector: 'app-make-payment',
    templateUrl: './make-payment.component.html',
    styleUrls: ['./make-payment.component.scss'],
    standalone: false
})
export class MakePaymentComponent implements OnInit {
  EModuleType = EModuleType;
  makePaymentMandate;
  notesMPaymentField: boolean;
  noPeriodMpaymentField: boolean;
  prePaymentPeriod = 0;
  paymentPrePaidPeriod: number = 0;
  customerDiscountList: any[] = [];
  IsEditPricingPromotion: boolean = false;
  masterCustomerDiscountList: any;
  depositPDIsEdit: boolean = false;
  rentPDIsEdit: boolean = false;
  feesPDIsEdit: boolean = false;
  propProtPDIsEdit: boolean = false;
  merchandisePDIsEdit: boolean = false;
  lateAndlienPDIsEdit: boolean = false;
  totalAllowance: number = 0;
  isPrePay: boolean;
  paymentSetting;
  userGroupLimits;
  billedThruDate;
  currentBTD;
  currentPTD;
  mpPTD;
  feesSection = false;
  AllowanceSection = false;
  propertyProtectionSection = false;
  PricingPromotionsSection = false;
  PaymentDistributionSection = false;
  disablePrePay: boolean;
  customerDuesDetails;
  tempDueDetails: any;
  intialDiscAmt: number = 0;
  totalCustomerDues: any;
  totalCustomerDuesTax: any;
  LettersByTemplates;
  partialPayReturn: Boolean = false;
  currentPeriodTotal = 0;
  feesChargesList = [];
  insuranceDetails: any = null;
  customerPrePayDues: any;
  mastercustomerDuesDetails;
  TotalRentDuePlusTotalDiscount = 0;
  discountPrepaycheck;
  allowanceNotes: any = '';
  lateLeinList: any[] = [];
  ledgerBreakdown = [];
  propertyProtectionLabel: string;
  appliedFeesAndCharges: any[];
  public LeaseStatus;
  isCustomerDetailsLoaded: Promise<boolean> = Promise.resolve(false);
  allowanceItemId: number = 0;
  allowanceError: number = 0;
  errorAllowanceCount: boolean = false;
  unitAllowanceCountList: any = null;
  errorPropertProtectionModel = false;
  miscellaneousSettings;
  FeesViewRight = false;
  FeesEditRight = false;
  PaidThroughDate;
  feesAndChargesDataGrid = [];
  manualFeesAndCharges = [];
  effectiveDatesList = [];
  stopDatesList = [];
  userGroupData: any;
  labelPricingPromotionAppliedPD: boolean = false;
  eNumActionTypes = EActionTypes;
  eNumElementTypes = EElementTypes;
  IsPaymentDistrDiscountisApplied: boolean = false;
  depositPD: any;
  rentPD: any;
  feesPD: any;
  propProtPD: any;
  merchandisePD: any;
  totalPD: any;
  lateAndlienPD: any;
  lateAndlienPDtemp: any;
  propProtlabPD: any;
  allowancePD: number;
  totalPaymentDist: any;
  totallabPD: any;
  depositPDlab: any;
  rentPDlab: any;
  feesPDlab: any;
  propProtPDlab: any;
  merchandisePDlab: any;
  lateAndlienPDlab: any;
  tempPDTotalCustomerDues: any = 0;
  public show_popup: BsModalRef;
  public pricingPromotionsList: IPricingPromotionsList[];
  public totPricePromotion = 0;
  public totFees;
  public NextBillingDate;
  public UnitNo;
  public Unitno: string;
  public UnitType;
  public BillingType;
  public BillingCycle;
  public LeaseNo;
  taxCalc;
  amtDueTotal;
  public LeaseId;
  MoveInDatePP;
  public PaidThruDate;
  public PropertyProtectionDate;
  public Autopay;
  LatestURCToDate;
  LatestURCToDatePlusOne;
  public Deposit;
  public Rent;
  public Fees;
  public LateandLienAmount;
  public TaxOnLateandLienAmount;
  public Discount;
  public Insurance;
  public Tax;
  public Balance;
  public Total;
  TaxTotalPopup: any;
  totalRentTax: any;
  totalFeesTax: any;
  totalPPTax: any;
  rentRaiseSettings;
  CustomerPropertyProtectionList = [];
  FacilityDate;
  NextDayendDate;
  propertyProtectionSetting = null;
  facilityMoveInSettings;
  selectedInsuranceId;
  initialPPSelected;
  PDDiscountList: any;
  depositAllowancePD: any;
  rentAllowancePD: any;
  feesAllowancePD: any;
  propProtAllowancePD: any;
  merchandiseAllowancePD: any;
  lateAndlienAllowancePD: any;
  rentPost: any = 0;
  rentTaxPost: any = 0;
  feesPost: any = 0;
  feesTaxPost: any = 0;
  propProtPDPost: any = 0;
  propProtPDTaxPost: any = 0;
  MerchandisePDPost: any = 0;
  MerchandisePDTaxPost: any = 0;
  LateAndlienPDPost: any = 0;
  LateAndlienPDTaxPost: any = 0;
  paymentSettings;
  prePayLimit = environment.prePayMaxLimit;
  facilityAllowanceItems: IFacilityAllowanceItemsModel[] = [];
  selectedAllowanceItemDetail = null;
  IsPaymentDistModify: boolean = false;
  rentTaxPosttemp: number;
  public facilityID: number;
  componentName: any = 'faceops-customer-rental.component.html';
  @ViewChild('partialPayForm', { static: true }) partialPayForm: NgForm;
  formNamePartialPay: any = 'partialPayForm';
  IsPaymentDist: boolean = false;
  cartItemsList: any = [];
  DelinquentCheckCount: number = 0;
  DelinquentDonotAcceptCheck: boolean = false;
  requireFullPaymentDelinquentCount: number = 0;
  requireFullPaymentDelinquent: boolean = false;
  AllowPartialPayTillPreviousPeriod: boolean = false;
  DaysAfterRentChargeToAllowPartialPay: number = 0;
  DelinquentStageStartDate;
  makePaymentNotes: string;
  isSaveAllowance = false;
  public modalRefConfirm: BsModalRef;
  amtPartialPayment: any;
  NotesPartialPayment: any = '';
  public tenantId: number;
  public modalRef: BsModalRef;
  public prioirity: boolean = false;
  documentView: boolean = false;
  Letterslist: any = [];
  defaultDocList: any = [];
  invoiceSettings: any;
  public customerDashboardDetails;
  isUnitDelinquent: boolean = false;
  payTillLastPeriod: boolean = false;
  lastPeriodToDate: any;

  allowanceDataList: {
    Id: number; Name: string; AllowanceType: number; totalAmount: any; Balance: any; Allowance: any; taxInfo: any;
    Amount: any; AppliedFeeDueID: any; RecurringFeeId: any
  }[] = [];
  ledgerDueTotal = {
    Deposit: 0,
    Rent: 0,
    Fee: 0,
    Insurance: 0,
    Merchandise: 0,
    Discount: 0,
    LateLien: 0,
    TotalTax: 0,
    Allowance: 0,
    Total: 0
  };

  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  datepipe: DatePipe = new DatePipe('en');
  customerPrePaySubscribe: Subscription;
  subscriptionPrePay: Subscription;
  public loaderIcon: Promise<boolean>;
  subjectPrePaymentPeriod: Subject<any> = new Subject();
  subjectSaveSAllowance: Subject<any> = new Subject();
  @ViewChild('PaymentDetailsModal', { static: true }) PaymentDetailsModal: ModalDirective;
  public unitDetail: IFacilityCustomerRentalUnitInfoModels = <IFacilityCustomerRentalUnitInfoModels>{};
  @ViewChild('templatePDConfirm', { static: true }) templatePDConfirm: ModalDirective;
  @ViewChild('PartialPaymentModal', { static: true }) PartialPaymentModal: ModalDirective;
  @ViewChild('showpopup', { static: true }) showpopup: TemplateRef<any>;
  @ViewChild('showpopupforpartialPayment', { static: true }) showpopupforpartialPayment: TemplateRef<any>;
  @ViewChild(FingerprintpopupComponent, { static: true }) FingerprintpopupComponent: FingerprintpopupComponent;
  @ViewChild(PropertyProtectionComponent, { static: false }) PropertyProtectionComponent: PropertyProtectionComponent;
  @Output() emitCartItems: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitInvoiceSettings: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitMakePay: EventEmitter<any> = new EventEmitter<any>();
  @Output() openModal = new EventEmitter<void>();
  
  @Output() emitPartialPayReturn: EventEmitter<any> = new EventEmitter<any>();
  modalConfig = {
  backdrop: 'static'
};
  ProrateRent: number;
  autoEnrolmentAutoEnrollPPPartialPayment: boolean;
  terminatedinsurencedue: any;
  chargesObjForPayment: IMakePaymentCharges;
  terminatedInsuranceTaxDue: any;
  isShowAutoEnrolledPopuUp: boolean=false;
  show_PartialPaymentPopup: boolean=false;
  AutoEnrollPropertyProtection: any;
  AutoEnrolExpiredInsWithNoCharge: any;
  autoEnrolmentfornopayment: boolean=false;
  show_zeroPaymentPopup: boolean = false;
  isfromMakePayment: boolean = false;
  CurrentURCFromDate: any;
  TotalSquareFoot: any;
  private customerPaymentDuesSubscribe: Subscription
  private paymentDuesLoaded$ = new Subject<void>();
  isPrePayPeriodRefetch = false;
  paymentModalDismissed = true;

  constructor(private generalService: GeneralService,
    private customerService: CustomerService,
    private prospectService: ProspectService,
    private commotMethodService: CommonMethodService,
    private userSessionService: UserSessionService,
    private data: DataService,
    public fingerPrintInitService: FingerPrintInitService,
    private propertyProtectionservice: PropProtecService,
    private currencyPipe: CurrencyPipe,
    private modalService: BsModalService,
    private toaster: ToastrService,
    private makePaymentService: MakePaymentService) { }

  ngOnInit(): void {
    this.userGroupLimits = this.generalService.UserPermissions.UserGroupOptionLimits.find((ele) => ele.OptionId == ELOV_LimitOptions.AddionalPrePayPerid);
    this.userGroupData = this.userSessionService.userSessionData.UserGroup.IndividualPermission;
    this.setUserPermissions();

    this.subjectSaveSAllowance.pipe(debounceTime(500),distinctUntilChanged()).subscribe(event => {
      this.validateSaveAllowance();
    });

    this.partialPayForm.form.addControl('mamtPartialPayment', new FormControl());
    this.partialPayForm.form.addControl('mNotesPartialPayment', new FormControl());
  }

  ngOnDestroy(): void {
    if (this.subscriptionPrePay) {
      this.subscriptionPrePay.unsubscribe();
    }
    if (this.customerPaymentDuesSubscribe) {
      this.customerPaymentDuesSubscribe.unsubscribe();
    }
    this.show_zeroPaymentPopup = false;
    this.show_PartialPaymentPopup = false;
  }

  setMandatoryField(formId: number) {
    this.loaderIcon = Promise.resolve(true);
    this.generalService.GetMandatoryFieldsById(null, formId)
      .subscribe((response: IGetPermissionMandatoryField) => {
        this.makePaymentMandate = response;
        this.noPeriodMpaymentField = this.makePaymentMandate.Form.ListOfProperties.find(o => o.Name == 'prePaymentPeriod').Required;
        this.notesMPaymentField = this.makePaymentMandate.Form.ListOfProperties.find(o => o.Name == 'makePaymentNotes').Required;
        this.loaderIcon = Promise.resolve(false);
      });
  }

  closemakePay() {
    this.PaymentDetailsModal.hide();
    this.prePaymentPeriod = 0;
    this.propertyProtectionSection = false;
    this.PricingPromotionsSection = false;
    this.feesSection = false;
    this.AllowanceSection = false;
    this.customerDuesDetails = this.createDueModel();
    this.allowanceDataList = [];
    this.feesChargesList = [];
    this.totalAllowance = 0;
    this.allowanceNotes = '';
    this.customerDiscountList = [];
    this.generalService.emitoAutEnrollPP = false;
    this.generalService.emitAutoEnrolwithNoDue = false;
    this.isUnitDelinquent = false;
    this.payTillLastPeriod = false;
    this.isPrePayPeriodRefetch = false;
    this.paymentModalDismissed = true;
    this.addAllowanceNotes(this.allowanceNotes);
  }

  makePayment(unitDetailLeaseNo, unitDetailFacilityID, unitDetailUnitId) {
    this.getDayEndCompletedDate(this.unitDetail.FacilityID);
    this.setMandatoryField(167);
    this.allowanceNotes = '';
    this.totalAllowance = 0;
    if (this.subscriptionPrePay) {
      this.subscriptionPrePay.unsubscribe();
    }
    this.IsPaymentDistrDiscountisApplied = false;
    this.PaymentDetailsModal.show();
    this.feesAndChargesDataGrid = [];
    this.allowanceDataList = [];
    this.AllowanceSection = false;
    this.allowanceNotes = '';
    this.prePaymentPeriod = 0;
    this.depositPD = 0
    this.rentPost = 0;
    this.rentTaxPost = 0;
    this.feesPost = 0;
    this.feesTaxPost = 0;
    this.propProtPDPost = 0;
    this.propProtPDTaxPost = 0;
    this.MerchandisePDPost = 0;
    this.MerchandisePDTaxPost = 0;
    this.LateAndlienPDPost = 0;
    this.LateAndlienPDTaxPost = 0;
    this.lateLeinList = [];
    this.isSaveAllowance = false;

    this.subscriptionPrePay = this.subjectPrePaymentPeriod.pipe(debounceTime(1000),distinctUntilChanged()).subscribe(event => {
      if (this.payTillLastPeriod && event.target.value > 0) {
        this.getLateAndLienSettings(unitDetailFacilityID);
        this.payTillLastPeriod = false;
        this.isPrePayPeriodRefetch = true;
        this.paymentModalDismissed = false;
        this.paymentDuesLoaded$.pipe(take(1)).subscribe(() => this.getPrePaymentPeriod(event));
        this.getCustomerPaymentDues(this.unitDetail.LeaseNo, this.unitDetail.FacilityID, this.unitDetail.UnitId);
      }
      else {
        this.paymentModalDismissed = false;
        this.getPrePaymentPeriod(event);
      }
    });
    this.makePaymentApiCalls(unitDetailLeaseNo, unitDetailFacilityID, unitDetailUnitId);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      return true;
    } else {
      return false;
    }
  }

  onPaste(event) {
    const pastedText = event.clipboardData.getData('text');
    let regexp = new RegExp('^[0-9]*$');
    return regexp.test(pastedText);
  }

  getPrePaymentPeriod(event) {
    let data = event.target.value;
    if (data == "") {
      this.prePaymentPeriod = 0;
      data = 0;
    }
    this.paymentPrePaidPeriod = data;
    this.prePayChangeOnDiscount(this.customerDiscountList, 2);
    this.PaymentDistributionSection = false;
    this.depositPDIsEdit = false;
    this.rentPDIsEdit = false;
    this.feesPDIsEdit = false;
    this.propProtPDIsEdit = false;
    this.merchandisePDIsEdit = false;
    this.lateAndlienPDIsEdit = false;
    this.loaderIcon = Promise.resolve(true);
    this.totalAllowance = 0;
    if (data != 0) {
      this.isPrePay = true;
      if (this.customerPrePaySubscribe) {
        this.customerPrePaySubscribe.unsubscribe();
      }
      if (
        this.generalService.UserPermissions.UserGroupOptionLimits.length > 0 &&
        this.paymentSetting.RestrictPrepay == false &&
        this.paymentSetting.RestrictedPrepayPeriod == 0
      ) {
        if (this.userGroupLimits) {
          if (data >= this.userGroupLimits.Limit) {
            this.prePaymentPeriod = this.userGroupLimits.Limit;
          }
        } else {
          this.prePaymentPeriod = data;
        }
      } else if (
        this.generalService.UserPermissions.UserGroupOptionLimits.length > 0 &&
        this.paymentSetting.RestrictPrepay == true &&
        this.paymentSetting.RestrictedPrepayPeriod > 0
      ) {
        if (this.userGroupLimits) {
          if (data >= this.paymentSetting.RestrictedPrepayPeriod + this.userGroupLimits.Limit) {
            this.prePaymentPeriod =
              this.paymentSetting.RestrictedPrepayPeriod +
              this.userGroupLimits.Limit;
          } else {
            this.prePaymentPeriod = data;
          }
        } else if (data >= this.paymentSetting.RestrictedPrepayPeriod) {
          this.prePaymentPeriod =
            this.paymentSetting.RestrictedPrepayPeriod.toString();
        } else {
          this.prePaymentPeriod = data;
        }
      } else if (
        this.generalService.UserPermissions.UserGroupOptionLimits.length == 0 &&
        this.paymentSetting.RestrictPrepay == true &&
        this.paymentSetting.RestrictedPrepayPeriod > 0
      ) {
        if (data >= this.paymentSetting.RestrictedPrepayPeriod) {
          this.prePaymentPeriod =
            this.paymentSetting.RestrictedPrepayPeriod.toString();
        } else {
          this.prePaymentPeriod = data;
        }
      } else if (this.generalService.UserPermissions.UserGroupOptionLimits.length == 0
        && !this.paymentSetting.RestrictPrepay && data > this.prePayLimit) {
        this.prePaymentPeriod = this.prePayLimit;
      }


      let chargesObj = this.createPrePaymentObj(this.prePaymentPeriod);
      chargesObj = JSON.parse(JSON.stringify(chargesObj));
      this.getCustomerPrePayAmt(chargesObj);
    } else {
      this.billedThruDate = this.currentBTD;
      this.mpPTD = this.currentPTD;
      this.isPrePay = false;
      this.editFees();
      this.disablePrePay = false;
      this.customerDuesDetails = JSON.parse(JSON.stringify(this.tempDueDetails));
      this.customerDuesDetails.TotalRentDue += this.intialDiscAmt;
      this.calculateCuatomerDues();
      this.allowanceDataList = [];
      let chargesObj = this.createPrePaymentObj(data);
      chargesObj = JSON.parse(JSON.stringify(chargesObj));
      this.getCustomerPrePayAmt(chargesObj);
    }
  }

  prePayChangeOnDiscount(discountList, type) {
    if (type == 1) {
      discountList.map((item) => {
        if (item.Selected && item.newlyChecked) {
          let applicablePeriods = item.ApplyAfter + 1 > item.PrePayPeriod ? item.ApplyAfter + 1 : item.PrePayPeriod;
          if (this.paymentPrePaidPeriod < applicablePeriods) {
            this.paymentPrePaidPeriod = applicablePeriods;
          }
        }
      })
    } else if (type == 2) {
      discountList.map((item) => {
        if (!item.ApplyDiscAutomatically && item.Selected) {
          let applicablePeriods = item.ApplyAfter + 1 > item.PrePayPeriod ? item.ApplyAfter + 1 : item.PrePayPeriod;
          if (this.paymentPrePaidPeriod < applicablePeriods) {
            item.Selected = false;
          }
        }
      })
    }
  }

  getCustomerDiscountsList(leaseNo, facilityId) {
    this.customerService.getCustomerDiscounts(leaseNo, facilityId, this.userSessionService.isCallcenterAgent).subscribe((response: ICustomerDiscounts[]) => {
      this.customerDiscountList = response;
      this.IsEditPricingPromotion = this.customerDiscountList.some(ele => ele.Selected) ? true : false;
      this.customerDiscountList.map((ele) => {
        ele['isActiveOnLoad'] = !!ele.Selected;
        ele['StopDate'] = ele.StopDate ? this.commotMethodService.getFormattedDate(ele.StopDate) : '';
        ele['ismodified'] = false;
      });
      this.masterCustomerDiscountList = JSON.parse(JSON.stringify(this.customerDiscountList));
    });
  }

  makePaymentApiCalls(leaseNo, facilityId, unitId) {
    this.IsPaymentDistModify = false;
    this.IsPaymentDist = false;
    this.PaymentDistributionSection = false;
    this.depositPD = 0;
    this.rentPD = 0;
    this.feesPD = 0;
    this.propProtPD = 0;
    this.merchandisePD = 0;
    this.lateAndlienPD = 0;
    this.totalPD = 0;
    this.getFacPaymentSettings(facilityId);
    this.getLettersByTemplates();
    this.getCustomerPaymentDues(leaseNo, facilityId, unitId);
    this.getLateAndLienSettings(facilityId);
    this.getCustomerFacilityMoveInSettings(facilityId);
    this.getCustomerDiscountsList(leaseNo, facilityId);
    this.getCustomerRentRaiseSettings(facilityId);
    this.getCustomerPropertyProtection(leaseNo, facilityId);
    this.getFacilityAllowanceItems(facilityId);
    this.getFacilityPaymentSettings(facilityId);
    this.getCustomerMiscSettings(facilityId);
    if (this.customerDuesDetails != undefined) {
      this.loadAllowanceList();
    }
    this.isPrePay = this.disablePrePay = false;
    this.feesSection = false;
  }

  getFacilityPaymentSettings(facilityId) {
    this.prospectService.getpaymentSettings(facilityId).subscribe((response: IFacPaymentSettingsDetails) => {
      this.paymentSetting = response;
    });
  }

  createPrePaymentObj(data) {
    let tempCustomerDiscountList = [];
    this.customerDiscountList.map(disc => {
      disc.PeriodStartDateTime = this.datepipe.transform(new Date(disc.PeriodStartDateTime), 'MM/dd/yyyy').toString();
      disc.StopDate = disc.StopDate ? (this.commotMethodService.isDateInFormat(disc.StopDate) ? this.commotMethodService.isDateInFormat(disc.StopDate) :
        this.datepipe.transform(new Date(disc.StopDate), 'MM/dd/yyyy')) : disc.StopDate;
      tempCustomerDiscountList.push(disc);
    });
    let tempFeesList = [];
    tempFeesList = JSON.parse(JSON.stringify(this.feesChargesList));
    tempFeesList.map(fee => {
      fee.EffectiveDate = this.commotMethodService.getDateTimeWithoutTimeForApi(fee.EffectiveDate);
      fee.StopDate = this.commotMethodService.getDateTimeWithoutTimeForApi(fee.StopDate);
    });
    let makePaymentChargesObj: IMakePaymentCharges = {
      LeaseNo: this.unitDetail.LeaseNo,
      FacilityId: this.unitDetail.FacilityID,
      BillingTypeId: this.unitDetail.BillingTypeId,
      BillingCycleId: this.unitDetail.BillingCycleId,
      PrepayPeriod: data == '' ? 0 : data,
      UnitId: this.unitDetail.UnitId,
      AppliedDiscounts: tempCustomerDiscountList,
      AppliedInsurance: this.insuranceDetails,
      AppliedFeeList: tempFeesList.filter((ele) => ele.FeesAndChargesId !== 0),
      PayTillLastPeriod: this.payTillLastPeriod ?? false
    }
    return makePaymentChargesObj;
  }

  calculateCuatomerDues() {
    if (this.customerDuesDetails != undefined) {
      let totalDues = this.customerDuesDetails.TotalRentDue + this.customerDuesDetails.TotalMerchandiseDue +
        this.customerDuesDetails.TotalLateLienChargeDue + this.customerDuesDetails.TotalInsuranceDue +
        this.customerDuesDetails.TotalFeesDue + this.customerDuesDetails.TotalDepositDue;

      let totalTax = this.customerDuesDetails.TotalRentTax + this.customerDuesDetails.TotalMerchandiseTax + this.customerDuesDetails.TotalLateLienTax +
        this.customerDuesDetails.TotalInsuranceTax + this.customerDuesDetails.TotalFeesTax;

      this.totalCustomerDuesTax = totalTax;
      this.totalCustomerDues = (totalDues + totalTax) - this.totalAllowance - this.customerDuesDetails.TotalDiscount;
      if ((this.unitDetail.LeaseId === 323 || this.unitDetail.LeaseId === 324 || this.unitDetail.LeaseId === 325 || this.unitDetail.LeaseId === 326) && this.unitDetail.Balance > 0) {
        if (this.LettersByTemplates == undefined) {
          this.partialPayReturn = false
        } else {
          this.partialPayReturn = this.totalCustomerDues <= 0 ? false : true;
        }
      } else {
        this.partialPayReturn = false;
      }
    }
    if (this.LettersByTemplates && this.LettersByTemplates.length == 0) {
      this.partialPayReturn = false;
    }
    if (this.prePaymentPeriod == 0) {
      this.currentPeriodTotal = this.totalCustomerDues;
    }
  }

  getCustomerPrePayAmt(obj) {
    this.customerPrePaySubscribe = this.customerService.getPrePaymentCharges(obj).subscribe(async (response: any) => {
      this.customerPrePayDues = response;
      this.syncFeeAmountsFromPrepayApi(response);
      this.billedThruDate = this.commotMethodService.getTimeZoneOffSetDate(response.BillThruDate);
      this.mpPTD = this.commotMethodService.getTimeZoneOffSetDate(response.PaidThruDate);
      let PeriodwiseCharges = response.PeriodwiseCharges;
      this.loaderIcon = Promise.resolve(false);
      this.generalService.stopLoaderEmitter.emit(true);
      this.customerDuesDetails = this.createDueModel();
      if (this.mastercustomerDuesDetails) {
        this.customerDuesDetails = JSON.parse(JSON.stringify(this.mastercustomerDuesDetails));
      }
      if (PeriodwiseCharges && PeriodwiseCharges.length > 0) {
        this.customerDuesDetails['TotalRentDue'] += this.intialDiscAmt + PeriodwiseCharges.reduce((sum, ele) => sum + ele.Rent, 0);
        this.customerDuesDetails['TotalFeesDue'] += PeriodwiseCharges.reduce((sum, ele) => sum + ele.Fee, 0);
        this.customerDuesDetails['TotalInsuranceDue'] += PeriodwiseCharges.reduce((sum, ele) => sum + ele.Insurance, 0);
        this.customerDuesDetails['TotalDiscount'] += PeriodwiseCharges.reduce((sum, ele) => sum + ele.Discount, 0);
        this.customerDuesDetails['TotalRentTax'] += PeriodwiseCharges.reduce((sum, ele) => sum + ele.RentTax, 0);
        this.customerDuesDetails['TotalFeesTax'] += PeriodwiseCharges.reduce((sum, ele) => sum + ele.FeeTax, 0);
        this.customerDuesDetails['TotalInsuranceTax'] += PeriodwiseCharges.reduce((sum, ele) => sum + ele.InsuranceTax, 0);
      } else {
        this.customerDuesDetails.TotalRentDue = JSON.parse(JSON.stringify(this.TotalRentDuePlusTotalDiscount));
      }
      this.prePaymentPeriod = this.customerPrePayDues.PrepayPeriod;
      this.calculateCuatomerDues();

      if (response.ProspectUnitLevelDiscounts && response.ProspectUnitLevelDiscounts.length) {
        const restrictPrepay = this.paymentSetting.RestrictPrepay && this.paymentSetting.RestrictedPrepayPeriod > 0;
        const userLimit = this.userGroupLimits ? this.userGroupLimits.Limit : 0;
        const restrictedPrepayPeriod = restrictPrepay ? this.paymentSetting.RestrictedPrepayPeriod : 0;
        this.customerDiscountList = [...response.ProspectUnitLevelDiscounts.map((ele) => {
          ele['enableDisc'] = ele.ApplyDiscAutomatically && !ele.AllowToOverrideDisc ? false : true;
          if (ele.CategoryId == EnumDiscount.PrePayment) {
            this.discountPrepaycheck = Math.max(ele.PrePayPeriod, ele.ApplyAfter + 1);
            if (this.discountPrepaycheck > (userLimit + restrictedPrepayPeriod)) {
              ele['enableDisc'] = false;
            }
          }
          return ele;
        })];
        this.customerDiscountList.forEach((ele) => {
          let discObj = this.masterCustomerDiscountList.find(item => item.DiscountId == ele.DiscountId);
          if (discObj) {
            ele['isActiveOnLoad'] = discObj['isActiveOnLoad'];
            ele['StopDate'] = ele.StopDate ? this.commotMethodService.getFormattedDate(ele.StopDate) : '';
          }
        });
      }

      this.allowanceDataList = [];
      this.allowanceNotes = '';
      await this.loadAllowanceList();
      if (this.payTillLastPeriod) {
        this.setPaymentDistributionPostValues();
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.generalService.stopLoaderEmitter.emit(true);
    });
    obj['RentAllowance'] = this.getRentAllowance(this.allowanceDataList, 2);
    obj['FeeAllowance'] = this.getRentAllowance(this.allowanceDataList, 4);
    obj['InsAllowance'] = this.getRentAllowance(this.allowanceDataList, 3);
    obj['DepositAllowance'] = this.getRentAllowance(this.allowanceDataList, 1);
    obj['MerchAllowance'] = this.getRentAllowance(this.allowanceDataList, 5);
    obj['LateLienAllowance'] = this.getRentAllowance(this.allowanceDataList, 6);
    obj['AllowanceList'] = this.allowanceDataList;
    obj['LateLienAllowanceList'] = this.lateLeinList;
    this.getLedgerBreakdown(obj);
  }

  private syncFeeAmountsFromPrepayApi(response: any) {
    const appliedFeesList = response?.AppliedFeesList;
    if (!appliedFeesList || !appliedFeesList.length || !this.feesAndChargesDataGrid?.length) {
      return;
    }

    const getNumber = (value: any): number => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const getFeeId = (item: any): number => {
      return getNumber(item?.FeesAndChargesId ?? item?.FeesandChargesId ?? item?.FeesId ?? item?.Id);
    };

    const getRecurringId = (item: any): number => {
      return getNumber(item?.RecurringFeeId ?? 0);
    };

    const getAppliedFeeDueId = (item: any): number => {
      return getNumber(item?.AppliedFeeDueID ?? item?.AppliedFeeDueId ?? item?.Id ?? 0);
    };

    const getAmount = (item: any): number => {
      return getNumber(item?.Amount ?? item?.Fee ?? 0);
    };

    this.feesAndChargesDataGrid.forEach((row) => {
      const rowFeeId = getFeeId(row);
      if (!rowFeeId || !row.selected) {
        return;
      }

      const rowRecurringId = getRecurringId(row);
      const rowAppliedFeeDueId = getAppliedFeeDueId(row);

      const matches = appliedFeesList.filter((apiItem: any) => {
        if (getFeeId(apiItem) !== rowFeeId) {
          return false;
        }

        const apiRecurringId = getRecurringId(apiItem);
        if (rowRecurringId > 0 && apiRecurringId !== rowRecurringId) {
          return false;
        }

        const apiAppliedFeeDueId = getAppliedFeeDueId(apiItem);
        if (rowAppliedFeeDueId > 0 && apiAppliedFeeDueId > 0 && apiAppliedFeeDueId !== rowAppliedFeeDueId) {
          return false;
        }

        return true;
      });

      if (matches.length) {
        row.Amount = matches.reduce((sum: number, item: any) => sum + getAmount(item), 0);
      }
    });

    if (this.feesChargesList?.length) {
      this.feesChargesList.forEach((fee) => {
        const feeFeeId = getFeeId(fee);
        const feeAppliedFeeDueId = getAppliedFeeDueId(fee);
        const feeRecurringId = getRecurringId(fee);
        const gridRow = this.feesAndChargesDataGrid.find((row) => getFeeId(row) === feeFeeId &&
          getAppliedFeeDueId(row) === feeAppliedFeeDueId && getRecurringId(row) === feeRecurringId);
        if (gridRow) {
          fee.Amount = gridRow.Amount;
        }
      });
    }
  }

  createDueModel() {
    let obj = {
      TotalDepositDue: 0,
      TotalRentDue: 0,
      TotalRentTax: 0,
      TotalFeesDue: 0,
      TotalFeesTax: 0,
      TotalInsuranceDue: 0,
      TotalInsuranceTax: 0,
      TotalMerchandiseDue: 0,
      TotalMerchandiseTax: 0,
      TotalLateLienChargeDue: 0,
      TotalLateLienTax: 0.0,
      TotalDiscount: 0.0,
      DiscountedRent: 0,
      TotalTax: 0,
      TotalAmount: 0,
      UnitNo: "",
      PaidThruDate: null,
      NextPaidThruDate: null,
      Dues: {
        Deposit: null,
        Rent: [],
        Discount: null,
        Fees: [],
        Insurance: [],
        Merchandise: [],
        LateLienCharge: [],
        TotalTaxuncharged: 0
      },
      CheckReversalCount: 0,
      AppliedDiscountsList: null,
      SurchargeFees: []
    }
    return obj;
  }

  async loadAllowanceList() {
    // AllowanceType: 1 - Deposit
    // AllowanceType: 2 - Rent
    // AllowanceType: 3 - Property Protection
    // AllowanceType: 4 - Fees
    // AllowanceType: 5 - Merchandise
    // AllowanceType: 6 - Late and Lein

    if (this.customerDuesDetails.TotalDepositDue > 0) {
      let obj = {
        Id: 0,
        Name: 'Deposit',
        AllowanceType: 1,
        totalAmount: this.customerDuesDetails.TotalDepositDue,
        Balance: this.customerDuesDetails.TotalDepositDue,
        Allowance: 0,
        taxInfo: 0,
        Amount: this.customerDuesDetails.TotalDepositDue,
        AppliedFeeDueID: 0,
        RecurringFeeId: 0
      };
      let index = this.allowanceDataList.findIndex(o => o.Name == 'Deposit' && o.Balance == obj.Balance);
      if (index != -1) {
        this.allowanceDataList.splice(index, 1);
      }
      if (!this.allowanceDataList.some(o => o.Name == 'Deposit')) {
        this.allowanceDataList.push(obj);
      }
    }
    if ((this.customerDuesDetails.TotalRentDue + this.customerDuesDetails.TotalRentTax) > 0) {
      let rentObj = {
        Id: 0,
        Name: 'Rent',
        AllowanceType: 2,
        totalAmount: this.customerDuesDetails.TotalRentDue + this.customerDuesDetails.TotalRentTax - this.customerDuesDetails.TotalDiscount,
        Balance: this.customerDuesDetails.TotalRentDue + this.customerDuesDetails.TotalRentTax - this.customerDuesDetails.TotalDiscount,
        Allowance: 0,
        taxInfo: [],
        Amount: this.customerDuesDetails.TotalRentDue,
        AppliedFeeDueID: 0,
        RecurringFeeId: 0
      };
      let index = this.allowanceDataList.findIndex(o => o.Name == 'Rent' && o.Balance == rentObj.Balance);
      if (index != -1) {
        this.allowanceDataList.splice(index, 1);
      }
      if (!this.allowanceDataList.some(o => o.Name == 'Rent')) {
        this.allowanceDataList.push(rentObj);
      }
    }

    if ((this.customerDuesDetails.TotalInsuranceDue + this.customerDuesDetails.TotalInsuranceTax) > 0) {
      let obj = {
        Id: 0,
        Name: this.propertyProtectionLabel,
        AllowanceType: 3,
        totalAmount: this.customerDuesDetails.TotalInsuranceDue + this.customerDuesDetails.TotalInsuranceTax,
        Balance: this.customerDuesDetails.TotalInsuranceDue + this.customerDuesDetails.TotalInsuranceTax,
        Allowance: 0,
        taxInfo: [],
        Amount: this.customerDuesDetails.TotalInsuranceDue,
        AppliedFeeDueID: 0,
        RecurringFeeId: 0
      };
      let index = this.allowanceDataList.findIndex(o => o.Name == this.propertyProtectionLabel && o.Balance == obj.Balance);
      if (index != -1) {
        this.allowanceDataList.splice(index, 1);
      }
      if (!this.allowanceDataList.some(o => o.Name == this.propertyProtectionLabel)) {
        this.allowanceDataList.push(obj);
      }
    }

    if ((this.customerDuesDetails.TotalMerchandiseDue + this.customerDuesDetails.TotalMerchandiseTax) > 0) {
      let obj = {
        Id: 0,
        Name: 'Merchandise',
        AllowanceType: 5,
        totalAmount: this.customerDuesDetails.TotalMerchandiseDue + this.customerDuesDetails.TotalMerchandiseTax,
        Balance: this.customerDuesDetails.TotalMerchandiseDue + this.customerDuesDetails.TotalMerchandiseTax,
        Allowance: 0,
        taxInfo: [],
        Amount: this.customerDuesDetails.TotalMerchandiseDue,
        AppliedFeeDueID: 0,
        RecurringFeeId: 0
      };
      let index = this.allowanceDataList.findIndex(o => o.Name == 'Merchandise' && o.Balance == obj.Balance);
      if (index != -1) {
        this.allowanceDataList.splice(index, 1);
      }
      if (!this.allowanceDataList.some(o => o.Name == 'Merchandise')) {
        this.allowanceDataList.push(obj);
      }
    }
    if ((this.customerDuesDetails.TotalLateLienChargeDue + this.customerDuesDetails.TotalLateLienTax) > 0) {
      if (this.lateLeinList && this.lateLeinList.length) {
        this.lateLeinList.forEach((ele) => {
          let obj = {
            Id: ele.FeesAndChargesId,
            Name: ele.Name,
            AllowanceType: 6,
            totalAmount: ele.Amount,
            Balance: ele.Amount,
            Allowance: 0,
            taxInfo: [],
            Amount: ele.Amount,
            AppliedFeeDueID: 0,
            RecurringFeeId: 0
          };
          let index = this.allowanceDataList.findIndex(o => o.Name == ele.Name && o.Balance == ele.Balance);
          if (index != -1) {
            this.allowanceDataList.splice(index, 1);
          }
          if (!this.allowanceDataList.some(o => o.Name == ele.Name)) {
            this.allowanceDataList.push(obj);
          }
        });
      }
    } else {
      this.lateLeinList = []
    }
    if (this.feesChargesList.length) {
      await this.generateFeesModelAllowance(this.feesChargesList);
    }
    if (this.allowanceDataList && this.allowanceDataList.length) {
      const tempDataList = JSON.parse(JSON.stringify(this.allowanceDataList));
      this.totalAllowance = tempDataList.reduce((sum, ele) => sum + parseFloat(ele.Allowance), 0);
    } else {
      this.totalAllowance = 0;
    }
    this.calculateCuatomerDues();
  }

  getRentAllowance(allowanceList, type) {
    if (allowanceList.length) {
      let Obj = allowanceList.find(o => o.AllowanceType === type);
      if (Obj) {
        if (type === 4 || type === 6) {
          let arr = allowanceList.filter((ele) => ele.AllowanceType === type);
          let allowance = arr.reduce((sum, ele) => parseFloat(sum) + parseFloat(ele.Allowance), 0);
          return allowance;
        }
        return Obj.Allowance;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  getLedgerBreakdown(obj) {
    this.makePaymentService.getLedgerBreakDown(obj).subscribe((response) => {
      this.ledgerBreakdown = response;
      if (response && response.length) {
        this.ledgerDueTotal['Deposit'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.Deposit, 0);
        this.ledgerDueTotal['Rent'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.Rent, 0);
        this.ledgerDueTotal['Fee'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.Fee, 0);
        this.ledgerDueTotal['Insurance'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.Insurance, 0);
        this.ledgerDueTotal['Merchandise'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.Merchandise, 0);
        this.ledgerDueTotal['Discount'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.Discount, 0);
        this.ledgerDueTotal['LateLien'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.LateLien, 0);
        this.ledgerDueTotal['TotalTax'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.TotalTax, 0);
        this.ledgerDueTotal['Allowance'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.Allowance, 0);
        this.ledgerDueTotal['Total'] = this.ledgerBreakdown.reduce((acc, a) => acc + a.Total, 0);
      } else {
        this.ledgerDueTotal['Deposit'] = 0;
        this.ledgerDueTotal['Rent'] = 0;
        this.ledgerDueTotal['Fee'] = 0;
        this.ledgerDueTotal['Insurance'] = 0;
        this.ledgerDueTotal['Merchandise'] = 0;
        this.ledgerDueTotal['Discount'] = 0;
        this.ledgerDueTotal['LateLien'] = 0;
        this.ledgerDueTotal['TotalTax'] = 0;
        this.ledgerDueTotal['Allowance'] = 0;
        this.ledgerDueTotal['Total'] = 0;
      }
    });
  }

  async generateFeesModelAllowance(array) {
    while (this.allowanceDataList.findIndex(item => (item.AllowanceType == 4)) != -1) {
      const index = this.allowanceDataList.findIndex(item => (item.AllowanceType == 4));
      if (index != -1) {
        this.allowanceDataList.splice(index, 1);
      }
    }
    this.mastercustomerDuesDetails.Dues.Fees.map((item) => {
      const feeAmount = item.Amount;
      let taxAmt = 0;
      if (item.Tax && item.Tax.length) {
        item.Tax.map(taxEle => {
          taxAmt = taxAmt + taxEle.AppliedTaxAmount;
        });
      }
      let feeAmountPlusTaxAmt = Math.round(parseFloat(feeAmount + taxAmt) * 100) / 100;

      let allowanceObj = {
        Id: item.FeesId,
        Name: item.Name,
        AllowanceType: 4,
        totalAmount: feeAmountPlusTaxAmt,
        Balance: feeAmountPlusTaxAmt,
        Allowance: 0,
        taxInfo: 0,
        Amount: feeAmountPlusTaxAmt,
        AppliedFeeDueID: item.Id,
        RecurringFeeId: item.RecurringFeeId,
        InvoiceFee: item.InvoiceFee ? item.InvoiceFee : false
      };
      this.allowanceDataList.push(allowanceObj);
      // if recurring fee should be handled - fee will also be listed in Customer AppliedFeeList
    });

    // since Charges for prepayment is fetched on loading make payment page: applied fee which is recurring will be handled below itself
    // along with manually applied fees
    // this.prePaymentPeriod > 0 since cuurent period charges will appear as due
    let periodwiseCharges;
    let periodwiseChargesForApplied = [];
    let periodWiseChargeFeeDuePresent = false;
    if (this.customerPrePayDues) {
      periodwiseCharges = JSON.parse(JSON.stringify(this.customerPrePayDues.PeriodwiseCharges));
      const tempPTD = this.commotMethodService.getAPIDateTimeToLocalDatePart(this.customerPrePayDues.BillThruDate);
      periodwiseCharges.map(rec => {
        if (rec.Fee + rec.FeeTax > 0) {
          periodWiseChargeFeeDuePresent = true;
        }
        rec.FromDate = this.commotMethodService.getAPIDateTimeToLocalDatePart(rec.FromDate);
        rec.ToDate = this.commotMethodService.getAPIDateTimeToLocalDatePart(rec.ToDate);
        if (rec.FromDate > tempPTD) {
          periodwiseChargesForApplied.push(rec);
        }
      });
    }
    if (this.customerPrePayDues != null && this.customerPrePayDues.AppliedFeesList != null && this.prePaymentPeriod > 0) {
      if (periodwiseChargesForApplied && periodwiseChargesForApplied.length && periodWiseChargeFeeDuePresent) {
        await Promise.all(
          this.appliedFeesAndCharges.map(async item => {
            // ActualRentForPeriod for percentage fee calculation
            // OneTimeFees is future period one time period applied
            if (item.OneTimeFees) {
              // verify if applicable for period selected
              // appliedFeesAndCharges is applied fees: contains applied future one time fee and applied recurring fees
              // appliedFeesAndCharges is not for current period
              const applicable = periodwiseChargesForApplied.find((period, index) => ( // index != 0 &&
                this.effectiveDateApplicableForPeriodRange(period.FromDate, period.ToDate, item.EffectiveDate, item.StopDate)));
              if (applicable) {
                let feeAmount = this.calculateFeesAmount(item.Value, item.Type, applicable.ActualRentForPeriod,item.Prorate);
                feeAmount = typeof (feeAmount) == 'string' ? parseFloat(feeAmount) : feeAmount;
                let taxAmt = 0;
                if (item.Tax && item.Tax.length) {
                  taxAmt = await this.commotMethodService.getTaxValue(item.Tax, feeAmount);
                }
                let feeAmountPlusTaxAmt = Math.round((feeAmount + taxAmt) * 100) / 100;
                let allowanceObj = {
                  Id: item.FeesAndChargesId,
                  Name: item.Name,
                  AllowanceType: 4,
                  totalAmount: feeAmountPlusTaxAmt,
                  Balance: feeAmountPlusTaxAmt,
                  Allowance: 0,
                  taxInfo: 0,
                  Amount: feeAmountPlusTaxAmt,
                  AppliedFeeDueID: item.AppliedFeeDueID,
                  RecurringFeeId: item.Recurring ? item.RecurringFeeId : 0
                };
                this.allowanceDataList.push(allowanceObj);
              }
            } else {
              await Promise.all(
                periodwiseChargesForApplied.map(async (period, index) => {
                  if (
                    this.effectiveDateApplicableForPeriodRange(period.FromDate, period.ToDate, item.EffectiveDate, item.StopDate)) {

                    let feeAmount = this.calculateFeesAmount(item.Value, item.Type, period.ActualRentForPeriod,item.Prorate);
                    feeAmount = typeof (feeAmount) == 'string' ? parseFloat(feeAmount) : feeAmount;
                    let taxAmt = 0;
                    if (item.Tax && item.Tax.length) {
                      taxAmt = await this.commotMethodService.getTaxValue(item.Tax, feeAmount);
                    }
                    let feeAmountPlusTaxAmt = Math.round((feeAmount + taxAmt) * 100) / 100;
                    let allowanceObj = {
                      Id: item.FeesAndChargesId,
                      Name: item.Name,
                      AllowanceType: 4,
                      totalAmount: feeAmountPlusTaxAmt,
                      Balance: feeAmountPlusTaxAmt,
                      Allowance: 0,
                      taxInfo: 0,
                      Amount: feeAmountPlusTaxAmt,
                      AppliedFeeDueID: item.AppliedFeeDueID,
                      RecurringFeeId: item.RecurringFeeId
                    };
                    const dueRecurringIndex = this.allowanceDataList.findIndex(all => (item.FeesAndChargesId == all.Id &&
                      all.RecurringFeeId == item.RecurringFeeId));
                    if (dueRecurringIndex != -1) {
                      this.allowanceDataList[dueRecurringIndex].Amount += allowanceObj.Amount;
                      this.allowanceDataList[dueRecurringIndex].totalAmount += allowanceObj.totalAmount;
                      this.allowanceDataList[dueRecurringIndex].Balance += allowanceObj.Balance;
                    } else {
                      this.allowanceDataList.push(allowanceObj);
                    }
                  }
                }));
            }
            // newly added Cuurent period and future period fees from this page will be pushed into fees and charges
          }));
      }
    }

    // newly added fee from the current page - cold be current period/future
    if (this.customerPrePayDues != null && this.customerPrePayDues.AppliedFeesList != null &&
      this.customerPrePayDues.AppliedFeesList.length > 0 && this.feesChargesList.length > 0) {
      let tempNewFeesAndChargesList = this.feesChargesList.filter(fee => fee.AppliedFeeDueID == 0 && fee.RecurringFeeId == 0
        && fee.selected);
      if (periodwiseCharges && periodwiseCharges.length && periodWiseChargeFeeDuePresent && tempNewFeesAndChargesList && tempNewFeesAndChargesList.length) {
        await Promise.all(tempNewFeesAndChargesList.map(async item => {
          if (item.OneTimeFees) {
            const applicable = periodwiseCharges.find((period, index) => (
              this.effectiveDateApplicableForPeriodRange(period.FromDate, period.ToDate, item.EffectiveDate, item.StopDate)));
            if (applicable) {
              let feeAmount = this.calculateFeesAmount(item.Value, item.Type, applicable.ActualRentForPeriod,item.Prorate);
              feeAmount = typeof (feeAmount) == 'string' ? parseFloat(feeAmount) : feeAmount;
              let taxAmt = 0;
              if (item.Prorate && this.dateIsInRange(applicable.FromDate, applicable.ToDate, new Date())) {
                feeAmount = this.commotMethodService.getProratedValue(this.unitDetail.BillingTypeId, feeAmount,
                  item.EffectiveDate, 0, null);
                feeAmount = this.commotMethodService.roundToTwo(feeAmount);
              }
              if (item.Tax && item.Tax.length) {
                taxAmt = await this.commotMethodService.getTaxValue(item.Tax, feeAmount);
              }

              let feeAmountPlusTaxAmt = Math.round((feeAmount + taxAmt) * 100) / 100;
              let allowanceObj = {
                Id: item.FeesAndChargesId,
                Name: item.Name,
                AllowanceType: 4,
                totalAmount: feeAmountPlusTaxAmt,
                Balance: feeAmountPlusTaxAmt,
                Allowance: 0,
                taxInfo: 0,
                Amount: feeAmountPlusTaxAmt,
                AppliedFeeDueID: item.AppliedFeeDueID,
                RecurringFeeId: item.RecurringFeeId
              };
              this.allowanceDataList.push(allowanceObj);
            }
          } else {
            await Promise.all(periodwiseCharges.map(async (period, index) => {
              if (
                this.effectiveDateApplicableForPeriodRange(period.FromDate, period.ToDate, item.EffectiveDate, item.StopDate)) {
                let feeAmount = this.calculateFeesAmount(item.Value, item.Type, period.ActualRentForPeriod,item.Prorate);
                feeAmount = typeof (feeAmount) == 'string' ? parseFloat(feeAmount) : feeAmount;
                if (item.Prorate && this.dateIsInRange(period.FromDate, period.ToDate, new Date())) {
                  feeAmount = this.commotMethodService.getProratedValue(this.unitDetail.BillingTypeId, feeAmount,
                    item.EffectiveDate, 0, null);
                  feeAmount = this.commotMethodService.roundToTwo(feeAmount);
                }
                let taxAmt = 0;
                if (item.Tax && item.Tax.length) {
                  taxAmt = await this.commotMethodService.getTaxValue(item.Tax, feeAmount);
                }
                let feeAmountPlusTaxAmt = Math.round((feeAmount + taxAmt) * 100) / 100;
                let allowanceObj = {
                  Id: item.FeesAndChargesId,
                  Name: item.Name,
                  AllowanceType: 4,
                  totalAmount: feeAmountPlusTaxAmt,
                  Balance: feeAmountPlusTaxAmt,
                  Allowance: 0,
                  taxInfo: 0,
                  Amount: feeAmountPlusTaxAmt,
                  AppliedFeeDueID: item.AppliedFeeDueID,
                  RecurringFeeId: item.RecurringFeeId
                };
                const recurringIndex = this.allowanceDataList.findIndex(all => (item.FeesAndChargesId == all.Id &&
                  all.RecurringFeeId == item.RecurringFeeId));
                if (recurringIndex != -1) {
                  this.allowanceDataList[recurringIndex].Amount += allowanceObj.Amount;
                  this.allowanceDataList[recurringIndex].totalAmount += allowanceObj.totalAmount;
                  this.allowanceDataList[recurringIndex].Balance += allowanceObj.Balance;
                } else {
                  this.allowanceDataList.push(allowanceObj);
                }
              }
            }));
          }
        }));
      }
    }
  }

  effectiveDateApplicableForPeriodRange(periodStart, periodEnd, effectiveDate, stopDate) {
    const periodStart1 = this.onPipeDate(periodStart);
    const periodEnd1 = this.onPipeDate(periodEnd);
    const effectiveDate1 = this.onPipeDate(effectiveDate);
    if (stopDate) {
      const stopDate1 = this.onPipeDate(stopDate);
      if (new Date(effectiveDate1) <= new Date(periodEnd1) && new Date(stopDate1) >= new Date(periodStart1) &&
        new Date(stopDate1) > new Date(effectiveDate1)) {
        return true;
      } else {
        return false;
      }
    } else {
      if (new Date(effectiveDate1) <= new Date(periodEnd1)) {
        return true;
      } else {
        return false;
      }
    }
  }

  onPipeDate(formDate) {
    if (formDate !== null && formDate !== '') {
      const date = new Date(formDate);
      return this.datepipe.transform(date, 'MM/dd/yyyy');
    }
  }

  calculateFeesAmount(value, type, rent,Prorate) {
    let amt = 0;
    let changedVal = parseFloat(value);
    if (changedVal === 0) {
      return amt;
    }
    if (type === 183) {
      amt = parseFloat(rent) * (changedVal / 100);
      return amt.toFixed(2);
    } else if (type === 184) {
      amt = changedVal;
      return amt.toFixed(2);
    } else if (type === 1009) {
      amt = changedVal * (this.TotalSquareFoot);
      return amt.toFixed(2);
    }
    else {
      if (Prorate) {
        amt = (this.ProrateRent - parseFloat(this.customerDuesDetails.TotalDiscount)) * (changedVal / 100);
      } else {
        var Discount = 0;
        if (this.ProrateRent > 0) {
          Discount = (parseFloat(rent) * parseFloat(this.customerDuesDetails.TotalDiscount)) / this.ProrateRent;
        } else {
          Discount = 0;
        }
        amt = (parseFloat(this.Rent) - Discount) * (changedVal / 100);
      }
      return amt.toFixed(2);
    }
  }

  dateIsInRange(periodStart, periodEnd, effectiveDate) {
    const periodStart1 = this.onPipeDate(periodStart);
    const periodEnd1 = this.onPipeDate(periodEnd);
    const effectiveDate1 = this.onPipeDate(effectiveDate);
    if (new Date(effectiveDate1) <= new Date(periodEnd1) && new Date(effectiveDate1) >= new Date(periodStart1)) {
      return true;
    } else {
      return false;
    }
  }

  disableLeaseStatus() {
    if (this.userGroupLimits != undefined || (this.paymentSetting && this.paymentSetting.RestrictPrepay && this.paymentSetting.RestrictedPrepayPeriod > 0)) {
      if (this.LeaseStatus == "Prepaid") {
        return true;
      } else {
        return false;
      }
    }
  }

  getCustomerPaymentDues(leaseNo, facilityId, UnitId) {
    if (this.customerPaymentDuesSubscribe) {
      this.customerPaymentDuesSubscribe.unsubscribe();
    }
    this.feesChargesList = [];
    this.feesAndChargesDataGrid = [];
    this.manualFeesAndCharges = [];
    this.appliedFeesAndCharges = [];
    this.unitAllowanceCountList = null;
    this.allowanceItemId = 0;
    this.errorAllowanceCount = false;
    this.errorPropertProtectionModel = false;
    this.allowanceError = 0;
    this.customerPrePayDues = null;
    this.prePaymentPeriod = (this.prePaymentPeriod > 0 && !this.payTillLastPeriod && !this.paymentModalDismissed) ? this.prePaymentPeriod : 0;
    this.paymentPrePaidPeriod = (this.paymentPrePaidPeriod > 0 && !this.payTillLastPeriod && !this.paymentModalDismissed) ? this.paymentPrePaidPeriod : 0;
    if (this.payTillLastPeriod) {
      this.billedThruDate = this.currentBTD;
    }
    else {
      this.currentBTD = null;
    }
    if (this.miscellaneousSettings == undefined && this.data.miscellaneousSettings != undefined &&
      this.data.miscellaneousSettings != null) {
      this.miscellaneousSettings = this.data.miscellaneousSettings;
    }
    if (this.miscellaneousSettings) {
      if (this.miscellaneousSettings.LimitAllowancesPerRental) {
        this.prospectService.GetAllowanceCount(leaseNo, null, facilityId).subscribe((response: IUnitAllowanceItemsCount[]) => {
          this.unitAllowanceCountList = {
            LeaseNo: leaseNo,
            FacilityId: facilityId,
            AllowanceList: response
          };
        });
      }
    }

    this.isCustomerDetailsLoaded = Promise.resolve(false);
    if (this.miscellaneousSettings == undefined && this.data.miscellaneousSettings != undefined &&
      this.data.miscellaneousSettings != null) {
      this.miscellaneousSettings = this.data.miscellaneousSettings;
    }
    if (this.FeesViewRight) {
      this.customerPaymentDuesSubscribe = forkJoin(this.customerService.getMakePaymentDues(leaseNo, facilityId, false, EPaymentTransactionTypes.Payment, this.payTillLastPeriod),
        this.customerService.getCustomerManualFeesAndCharges(UnitId, facilityId),
        this.customerService.getCustomerAppliedFeesAndCharges(leaseNo, facilityId))
        .subscribe(([response1, response2, response3]) => {
          this.mapFeesAndPaymentDues(response1, response2, response3);
        });
    } else {
      this.customerPaymentDuesSubscribe = forkJoin(this.customerService.getMakePaymentDues(leaseNo, facilityId, false, EPaymentTransactionTypes.Payment, this.payTillLastPeriod),
        this.customerService.getCustomerAppliedFeesAndCharges(leaseNo, facilityId))
        .subscribe(([response1, response3]) => {
          this.mapFeesAndPaymentDues(response1, [], response3);
        });
    }
  }

  checkPayTillLastPeriod(event) {
    this.payTillLastPeriod = event.target.checked;
    if (this.autoEnrolmentfornopayment && this.payTillLastPeriod) {
      this.show_zeroPaymentPopup = true;
      this.isfromMakePayment = true;
    }
    else if (this.autoEnrolmentAutoEnrollPPPartialPayment && this.payTillLastPeriod) {
      this.isfromMakePayment = true;
      this.show_PartialPaymentPopup = true;
    }
    else {
      this.getCustomerPaymentDues(this.unitDetail.LeaseNo, this.unitDetail.FacilityID, this.unitDetail.UnitId);
    }
  }

  mapFeesAndPaymentDues(response1, response2, response3) {
    this.isCustomerDetailsLoaded = Promise.resolve(true);
    this.customerDuesDetails = response1;
    if ((response1.AutoEnrollPropertyProtection || response1.AutoEnrolExpiredInsWithNoCharge) && !this.payTillLastPeriod) {
       this.AutoEnrollPropertyProtection = response1.AutoEnrollPropertyProtection;
      this.AutoEnrolExpiredInsWithNoCharge = response1.AutoEnrolExpiredInsWithNoCharge;
      this.isShowAutoEnrolledPopuUp = true
    }
    if (response1.CurrentURCFromDate) {
      this.CurrentURCFromDate = response1.CurrentURCFromDate;
    }
    this.mpPTD = this.commotMethodService.getTimeZoneOffSetDate(response1.PaidThruDate);
    if (response1.PaidThruDate != null) {
      this.currentPTD = JSON.parse(JSON.stringify(this.commotMethodService.getTimeZoneOffSetDate(response1.PaidThruDate)));
      this.PaidThroughDate = this.currentPTD;
    }
    if (!this.payTillLastPeriod) {
      this.billedThruDate = this.commotMethodService.getTimeZoneOffSetDate(response1.BillThruDate);
      if (response1.BillThruDate != null) {
        this.currentBTD = JSON.parse(JSON.stringify(this.commotMethodService.getAPIDateTimeToLocalDatePart(response1.BillThruDate)));
      }
    }
    if (this.customerDuesDetails.Dues.Rent.length > 1 && this.AllowPartialPayTillPreviousPeriod && !this.isUnitDelinquent){
      const today = new Date(this.FacilityDate);
      const urcFromDateString = String(this.CurrentURCFromDate).substring(0, 10);
      const URCFromDate = new Date(`${urcFromDateString}T00:00:00`);
      let daysAfterRentCharge = (URCFromDate > today ? 0 : this.commotMethodService.dateDiff(URCFromDate, today) + 1);
      if (daysAfterRentCharge <= this.DaysAfterRentChargeToAllowPartialPay) {
        this.isUnitDelinquent = true;
        const lastPeriodDate = new Date(`${urcFromDateString}T00:00:00`);
        lastPeriodDate.setDate(lastPeriodDate.getDate() - 1);
        this.lastPeriodToDate = lastPeriodDate;
      }
    }
    this.intialDiscAmt = JSON.parse(JSON.stringify(this.customerDuesDetails.TotalDiscount));
    this.customerDuesDetails.Dues.Fees.some(ele => {
      let flag = this.feesChargesList.findIndex(fee => fee.FeesAndChargesId == ele.FeesId && fee.AppliedFeeDueID == ele.Id &&
        fee.RecurringFeeId == ele.RecurringFeeId);
      if (flag == -1) {
        const feeManual = response2.find(fee => fee.FeesandChargesId == ele.FeesId);
        const feeApplied = response3.find(fee => fee.FeesAndChargesId == ele.FeesId);
        const tempType = feeManual ? feeManual.Type : (feeApplied ? feeApplied.Type : ele.Type);
        const tempTypeName = tempType == 183 ? 'Percentage' : tempType == 184 ? 'Fixed' : 'Percentage on Discounted Rent';
        let feeObj = {
          AppliedFeeDueID: ele.Id,
          RecurringFeeId: ele.RecurringFeeId,
          FeesAndChargesId: ele.FeesId,
          Name: ele.Name,
          OneTimeFees: ele.Recurring === true ? false : true,
          EffectiveDate: this.commotMethodService.getTimeZoneOffSetDate(ele.FromDate),
          StopDate: this.commotMethodService.getTimeZoneOffSetDate(ele.ToDate),
          TypeName: tempTypeName,
          Type: tempType,
          Value: feeManual ? feeManual.Value : (feeApplied ? feeApplied.Value : tempTypeName == 'Fixed' ? ele.Amount : ele.Value),
          Amount: ele.Amount,
          InitialValue: feeManual ? feeManual.Value : (feeApplied ? feeApplied.Value : ele.Value),
          Notes: null,
          Stopped: false,
          AppliedFee: true,
          edit: true,
          ApplyManually: false,
          selected: true,
          Modified: false,
          IsError: false,
          IsCharitableFee: false,
          FixedCharityAmount: false,
          OverrideCharityAmount: false,
          CharityAmount: 0,
          RoundUpCharityAmount: false,
          RoundUpAmount: 0,
          AllowToOverride: false,
          Tax: [],
          Prorate: false
        }
        if (ele.Recurring == false || (ele.InvoiceFee && ele.Recurring)) {
          this.feesChargesList.push(feeObj);
          if (!ele.Recurring) {
            this.feesAndChargesDataGrid.push(feeObj);
          }
        }
      }
    });
    if (this.customerDuesDetails.Dues.LateLienCharge && this.customerDuesDetails.Dues.LateLienCharge.length) {
      this.setLateLeinAllowance(this.customerDuesDetails.Dues.LateLienCharge);
    }
    this.tempDueDetails = JSON.parse(JSON.stringify(response1));
    this.mastercustomerDuesDetails = JSON.parse(JSON.stringify(response1));
    if (response2 && response2.length) {
      let tempArr = [];
      let amount;
      response2.map((ele) => {
        let typeName;
        if (ele.Type === 183) {
          typeName = 'Percentage';
        } else if (ele.Type === 184) {
          typeName = 'Fixed';
        } else if (ele.Type === 1009) {
          typeName = 'Price Per Square Foot';
        } else {
          typeName = 'Percentage on Discounted Rent';
        }
        const limit = this.userGroupData.UserGroupFeesAndChargesLimits.find(feelimit =>
          feelimit.FeesAndChargesId == ele.FeesandChargesId)
        if (limit) {
          if (limit.ValueAmt < ele['MaxValue']) {
            ele['MaxValue'] = limit.ValueAmt;
          }
        }
        let obj = {
          AppliedFeeDueID: 0,
          RecurringFeeId: 0,
          FeesAndChargesId: ele.FeesandChargesId,
          Name: ele.FeesandChargesName,
          OneTimeFees: ele.Recurring === true ? false : true,
          EffectiveDate: new Date(),
          StopDate: null,
          TypeName: typeName,
          Type: ele.Type,
          Value: ele.Value,
          Amount: amount,
          InitialValue: ele.Value,
          Notes: null,
          Stopped: false,
          AppliedFee: false,
          edit: true,
          ApplyManually: true,
          Modified: false,
          IsError: false,
          MinValue: ele.MinValue,
          MaxValue: ele.MaxValue,
          IsCharitableFee: false,
          FixedCharityAmount: false,
          OverrideCharityAmount: false,
          CharityAmount: 0,
          RoundUpCharityAmount: false,
          RoundUpAmount: 0,
          AllowToOverride: ele.AllowToOverride,
          Tax: ele.AppliedFeesandChargesTaxInfo,
          Prorate: ele.Prorate
        };
        tempArr.push(obj);
      });
      this.manualFeesAndCharges = tempArr;
      let tempFee = [];
      this.mastercustomerDuesDetails.Dues.Fees.map((ele) => {
        const feeManual = response2.find(fee => fee.FeesandChargesId == ele.FeesId);
        const feeApplied = response3.find(fee => fee.FeesAndChargesId == ele.FeesId);
        const tempType = feeManual ? feeManual.Type : (feeApplied ? feeApplied.Type : 184);
        const tempTypeName = tempType == 183 ? 'Percentage' : tempType == 184 ? 'Fixed' : 'Percentage on Discounted Rent';
        let obj = {
          AppliedFeeDueID: ele.Id,
          RecurringFeeId: ele.RecurringFeeId,
          FeesAndChargesId: ele.FeesId,
          Name: ele.Name,
          OneTimeFees: ele.Recurring === true ? false : true,
          EffectiveDate: this.commotMethodService.getTimeZoneOffSetDate(ele.FromDate),
          StopDate: this.commotMethodService.getTimeZoneOffSetDate(ele.ToDate),
          TypeName: tempTypeName,
          Type: tempType != null ? ele.Type : tempType,
          Value: feeManual ? feeManual.Value : (feeApplied ? feeApplied.Value : tempTypeName == 'Fixed' ? ele.Amount : ele.Value),
          Amount: ele.Amount,
          InitialValue: feeManual ? feeManual.Value : (feeApplied ? feeApplied.Value : ele.Value),
          Notes: null,
          Stopped: false,
          AppliedFee: true,
          edit: true,
          ApplyManually: false,
          selected: true,
          Modified: false,
          IsError: false,
          IsCharitableFee: false,
          FixedCharityAmount: false,
          OverrideCharityAmount: false,
          CharityAmount: 0,
          RoundUpCharityAmount: false,
          RoundUpAmount: 0,
          Tax: [],
          Prorate: false,
          AllowToOverride: false
        };
        if (ele.Recurring == false) {
          tempFee.push(obj);
        }
      });
      this.feesAndChargesDataGrid = tempFee;
      this.editFees();
      this.disablePrePay = false;
    }
    this.appliedFeesAndCharges = [];
    if (response3.length) {
      this.appliedFeesAndCharges = response3;
      this.appliedFeesAndCharges.map((ele) => {
        ele['AppliedFeeDueID'] = 0;
        let matchingDue = null;
        if (this.mastercustomerDuesDetails.Dues.Fees) {
          matchingDue = this.mastercustomerDuesDetails.Dues.Fees.find(due => due.FeesId == ele.FeesAndChargesId && due.RecurringFeeId == ele.RecurringFeeId);
          if (matchingDue) {
            ele['AppliedFeeDueID'] = matchingDue.Id;
          }
        }
        ele['ApplyManually'] = false;
        ele['AppliedFee'] = true;
        ele['selected'] = true;
        ele['edit'] = false;
        ele['Modified'] = false;
        ele['IsError'] = false;
        ele['EffectiveDate'] = this.commotMethodService.getTimeZoneOffSetDate(ele.EffectiveDate);
        if (ele.Type === 183) {
          ele['TypeName'] = 'Percentage';
        } else if (ele.Type === 184) {
          ele['TypeName'] = 'Fixed';
        } else if (ele.Type === 1009) {
          ele['TypeName'] = 'Price Per Square Foot';
        } else {
          ele['TypeName'] = 'Percentage on Discounted Rent';
        }
        ele['Stopped'] = false;
        ele['StopDate'] = ele.StopDate ? this.commotMethodService.getTimeZoneOffSetDate(ele.StopDate) : ele.StopDate;
        ele['Amount'] = matchingDue ? matchingDue.Amount : this.calculateFeesAmount(ele.Value, ele.Type, this.Rent,ele.Prorate);
        ele['InitialValue'] = ele.Value;
        ele['AllowToOverride'] = false;
        let index = this.feesChargesList.findIndex(o => o.FeesAndChargesId === ele.FeesAndChargesId &&
          o.AppliedFeeDueID === ele.AppliedFeeDueID && o.RecurringFeeId === ele.RecurringFeeId);
        if (index == -1) {
          this.feesChargesList.push(ele);
        }
      });
      this.feesAndChargesDataGrid = this.feesAndChargesDataGrid.concat(...this.appliedFeesAndCharges);
    }
    let arr = [];
    this.feesAndChargesDataGrid.forEach((ele) => {
      let index = arr.findIndex(o => o.FeesAndChargesId === ele.FeesAndChargesId && o.AppliedFeeDueID === ele.AppliedFeeDueID
        && o.RecurringFeeId === ele.RecurringFeeId);
      if (index === -1) {
        arr.push(ele);
      }
    });
    this.feesAndChargesDataGrid = arr;
    this.customerDuesDetails.TotalRentDue += this.customerDuesDetails.TotalDiscount;
    this.TotalRentDuePlusTotalDiscount = JSON.parse(JSON.stringify(this.customerDuesDetails.TotalRentDue));
    this.calculateCuatomerDues();
    let chargesObj = this.createPrePaymentObj(this.paymentPrePaidPeriod);
    chargesObj = JSON.parse(JSON.stringify(chargesObj));
    this.getCustomerPrePayAmt(chargesObj);
    if (this.isPrePayPeriodRefetch) {
      this.isPrePayPeriodRefetch = false;
      this.paymentDuesLoaded$.next();
    }
  }

  setPaymentDistributionPostValues() {
    if (this.customerDuesDetails != undefined) {
      this.depositPD = this.customerDuesDetails.TotalDepositDue;
      this.depositPD = this.allowanceDataList.find(o => o.AllowanceType === 1) && this.allowanceDataList.find(o => o.AllowanceType === 1).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 1).Balance : this.depositPD;
      this.feesPD = this.customerDuesDetails.TotalFeesDue + this.customerDuesDetails.TotalFeesTax;
      this.feesPD = this.allowanceDataList.find(o => o.AllowanceType === 4) && this.allowanceDataList.find(o => o.AllowanceType === 4).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 4).Balance : this.feesPD;
      this.propProtPD = this.customerDuesDetails.TotalInsuranceDue + this.customerDuesDetails.TotalInsuranceTax;
      this.propProtlabPD = this.customerDuesDetails.TotalInsuranceDue + this.customerDuesDetails.TotalInsuranceTax;
      this.propProtPD = this.allowanceDataList.find(o => o.AllowanceType === 3) && this.allowanceDataList.find(o => o.AllowanceType === 3).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 3).Balance : this.propProtPD;
      this.merchandisePD = this.customerDuesDetails.TotalMerchandiseDue + this.customerDuesDetails.TotalMerchandiseTax;
      this.merchandisePD = this.allowanceDataList.find(o => o.AllowanceType === 5) && this.allowanceDataList.find(o => o.AllowanceType === 5).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 5).Balance : this.merchandisePD;
      this.lateAndlienPD = this.customerDuesDetails.TotalLateLienChargeDue + this.customerDuesDetails.TotalLateLienTax;
      this.lateAndlienPD = this.allowanceDataList.find(o => o.AllowanceType === 6) && this.allowanceDataList.find(o => o.AllowanceType === 6).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 6).Balance : this.lateAndlienPD;
      this.lateAndlienPDtemp = this.customerDuesDetails.TotalLateLienChargeDue + this.customerDuesDetails.TotalLateLienTax;
      this.allowancePD = this.totalAllowance
      this.rentPD = this.customerDuesDetails.TotalRentDue + this.customerDuesDetails.TotalRentTax - (this.customerDuesDetails.TotalDiscount);
      this.rentPD = this.allowanceDataList.find(o => o.AllowanceType === 2) && this.allowanceDataList.find(o => o.AllowanceType === 2).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 2).Balance - this.customerDuesDetails.TotalDiscount : this.rentPD;
      this.totalPD = (this.depositPD + this.rentPD + this.feesPD + this.propProtPD + this.merchandisePD + this.lateAndlienPD);
      this.totalPaymentDist = this.totalPD;
      this.totallabPD = this.totalPaymentDist;
      this.depositPDlab = this.depositPD;
      this.rentPDlab = this.rentPD;
      this.feesPDlab = this.feesPD;
      this.propProtPDlab = this.propProtPD;
      this.merchandisePDlab = this.merchandisePD;
      this.lateAndlienPDlab = this.lateAndlienPD;
      this.tempPDTotalCustomerDues = this.totallabPD;
      this.currencyInputChanged(this.depositPD, 'depositPD');
      this.currencyInputChanged(this.rentPD, 'rentPD');
      this.currencyInputChanged(this.feesPD, 'feesPD');
      this.currencyInputChanged(this.propProtPD, 'propProtPD');
      this.currencyInputChanged(this.merchandisePD, 'merchandisePD');
      this.currencyInputChanged(this.lateAndlienPD, 'lateAndlienPD');
    }
  }

  setLateLeinAllowance(lateLienList) {
    let arr = [];
    lateLienList.forEach((ele) => {
      let index = arr.findIndex(o => o.FeesAndChargesId == ele.LateAndLienId); //
      if (index == -1) {
        let multipleLateLien = lateLienList.filter((lateObj) => lateObj.LateAndLienId == ele.LateAndLienId);
        let amt = 0;
        let tax = 0;
        if (multipleLateLien && multipleLateLien.length > 1) {
          amt = multipleLateLien.reduce((sum, b) => sum + b.Amount, 0);
          multipleLateLien.forEach((taxObj) => {
            if (taxObj.Tax && taxObj.Tax.length) {
              tax += taxObj.Tax.reduce((sum, b) => sum + b.AppliedTaxAmount, 0);
            }
          });
        } else {
          amt = ele.Amount;
          if (ele.Tax && ele.Tax.length) {
            tax = ele.Tax.reduce((sum, b) => sum + b.AppliedTaxAmount, 0);
          }
        }
        let obj = {
          FeesAndChargesId: ele.LateAndLienId,
          AppliedFeeDueID: ele.Id,
          Name: ele.Name,
          Value: amt,
          Amount: amt + tax,
          Allowance: null
        };
        if (obj.Amount > 0) {
          arr.push(obj);
        }
      }
    });
    this.lateLeinList = arr;
  }

  editFees() {
    this.feesSection = true;
    this.AllowanceSection = false;
    this.propertyProtectionSection = false;
    this.PricingPromotionsSection = false;
    this.PaymentDistributionSection = false;
  }

  editPricingPromotions() {
    this.PricingPromotionsSection = true;
    this.propertyProtectionSection = false;
    this.feesSection = false;
    this.AllowanceSection = false;
    this.PaymentDistributionSection = false;
  }

  editPropertyProtection() {
    this.propertyProtectionSection = true;
    this.feesSection = false;
    this.AllowanceSection = false;
    this.PricingPromotionsSection = false;
    this.PaymentDistributionSection = false;
  }

  editAllowances() {
    this.feesSection = false;
    this.AllowanceSection = true;
    this.propertyProtectionSection = false;
    this.PricingPromotionsSection = false;
    this.PaymentDistributionSection = false;
    if (this.prePaymentPeriod == 0) {
      this.disablePrePay = false;
    }
  }

  getCustomerMiscSettings(facilityId) {
    this.prospectService.getFacilityMiscellaneousSettings(facilityId).subscribe((response) => {
      this.miscellaneousSettings = response;
      if (this.miscellaneousSettings == null || this.miscellaneousSettings === "")
        this.propertyProtectionLabel = "Property Protection";
      else if (this.miscellaneousSettings.PropertyProtectionTerminology == null || this.miscellaneousSettings.PropertyProtectionTerminology === "")
        this.propertyProtectionLabel = "Property Protection";
      else
        this.propertyProtectionLabel = this.miscellaneousSettings.PropertyProtectionTerminology;
      this.data.tempInsuranceLabel = this.propertyProtectionLabel;
      if (this.miscellaneousSettings && this.miscellaneousSettings.UserAuthenticationforNonFinancial) {
        this.fingerPrintInitService.emitCaptureEvent.subscribe((resp) => {
          if (resp && resp.modType == 2) {
            if (resp && resp.caltureResponse && resp.caltureResponse.Success) {
              this.FingerprintpopupComponent.isFingerprintAcquired = true;
              this.FingerprintpopupComponent.initials = '';
              this.FingerprintpopupComponent.pin = '';
              this.FingerprintpopupComponent.fingerPrintAuthModal.hide();
              this.fingerPrintInitService.stopCapture();
              this.emitFingerPrintSuccess('');
            } else {
              this.FingerprintpopupComponent.isFingerprintAcquired = false;
              this.FingerprintpopupComponent.fingerprintMessage = resp.caltureResponse.Message;
            }
          }
        });
      }
    });
  }

  emitFingerPrintSuccess(data) {
    if (this.isSaveAllowance) {
      this.makePayNow(2);
    }
  }

  Allowancedisable() {
    if (this.unitAllowanceCountList) {
      const allowanceCountObj = this.unitAllowanceCountList.AllowanceList.find(item => (item.AllowanceCount));
      if (allowanceCountObj) {
        if (this.miscellaneousSettings.AllowanceLimit == allowanceCountObj.AllowanceCount) {
          this.errorAllowanceCount = true;
          return true;
        }
      } else {
        this.errorAllowanceCount = false;
        return false;
      }
    }
  }

  editPaymentDistribution() {
    this.PaymentDistributionSection = true;
    this.PricingPromotionsSection = false;
    this.propertyProtectionSection = false;
    this.feesSection = false;
    this.AllowanceSection = false;
    this.IsPaymentDistrDiscountisApplied = false;
    if (this.customerDuesDetails != undefined) {
      this.depositPD = this.customerDuesDetails.TotalDepositDue;
      this.depositPD = this.allowanceDataList.find(o => o.AllowanceType === 1) && this.allowanceDataList.find(o => o.AllowanceType === 1).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 1).Balance : this.depositPD;
      this.feesPD = this.customerDuesDetails.TotalFeesDue + this.customerDuesDetails.TotalFeesTax;
      this.feesPD = this.allowanceDataList.find(o => o.AllowanceType === 4) && this.allowanceDataList.find(o => o.AllowanceType === 4).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 4).Balance : this.feesPD;

      this.propProtPD = this.customerDuesDetails.TotalInsuranceDue + this.customerDuesDetails.TotalInsuranceTax;
      this.propProtlabPD = this.customerDuesDetails.TotalInsuranceDue + this.customerDuesDetails.TotalInsuranceTax;
      this.propProtPD = this.allowanceDataList.find(o => o.AllowanceType === 3) && this.allowanceDataList.find(o => o.AllowanceType === 3).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 3).Balance : this.propProtPD;

      this.merchandisePD = this.customerDuesDetails.TotalMerchandiseDue + this.customerDuesDetails.TotalMerchandiseTax;
      this.merchandisePD = this.allowanceDataList.find(o => o.AllowanceType === 5) && this.allowanceDataList.find(o => o.AllowanceType === 5).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 5).Balance : this.merchandisePD;

      this.lateAndlienPD = this.customerDuesDetails.TotalLateLienChargeDue + this.customerDuesDetails.TotalLateLienTax;
      this.lateAndlienPD = this.allowanceDataList.find(o => o.AllowanceType === 6) && this.allowanceDataList.find(o => o.AllowanceType === 6).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 6).Balance : this.lateAndlienPD;

      this.lateAndlienPDtemp = this.customerDuesDetails.TotalLateLienChargeDue + this.customerDuesDetails.TotalLateLienTax;
      this.allowancePD = this.totalAllowance
      this.rentPD = this.customerDuesDetails.TotalRentDue + this.customerDuesDetails.TotalRentTax - (this.customerDuesDetails.TotalDiscount);
      this.rentPD = this.allowanceDataList.find(o => o.AllowanceType === 2) && this.allowanceDataList.find(o => o.AllowanceType === 2).Allowance != 0 ? this.allowanceDataList.find(o => o.AllowanceType === 2).Balance - this.customerDuesDetails.TotalDiscount : this.rentPD;
      this.totalPD = (this.depositPD + this.rentPD + this.feesPD + this.propProtPD + this.merchandisePD + this.lateAndlienPD);
      this.totalPaymentDist = this.totalPD;
      this.totallabPD = this.totalPaymentDist;
      this.depositPDlab = this.depositPD;
      this.rentPDlab = this.rentPD;
      this.feesPDlab = this.feesPD;
      this.propProtPDlab = this.propProtPD;
      this.merchandisePDlab = this.merchandisePD;
      this.lateAndlienPDlab = this.lateAndlienPD;
      this.tempPDTotalCustomerDues = this.totalCustomerDues
    }
  }

  setUserPermissions() {
    let ufFees = this.generalService.getUserPermissionsForModule(EUserFunctions['Modify Rental : Add Fees & Charges']);
    this.FeesViewRight = ufFees.ViewRight;
    this.FeesEditRight = ufFees.CreateRight;
  }

  getUnitDetail(tenantId: number, leaseNo: number, facilityID: number) {
    this.loaderIcon = Promise.resolve(true);
    this.customerService.GetCustomerRentalDetails(tenantId, leaseNo, facilityID)
      .subscribe((response: IFacilityCustomerRentalUnitInfoModels) => {
        this.unitDetail = response;
        this.pricingPromotionsList = this.unitDetail.PricingPromotionsList;
        this.getCustomerInvoiceSettings(this.unitDetail.LeaseNo, this.unitDetail.FacilityID);
        this.LeaseNo = this.unitDetail.LeaseNo;
        this.LeaseStatus = this.unitDetail.LeaseStatus;
        this.LeaseId = this.unitDetail.LeaseId;
        this.UnitNo = this.unitDetail.UnitNo;
        this.UnitType = this.unitDetail.UnitType;
        this.BillingType = this.unitDetail.BillingType;
        this.BillingCycle = this.unitDetail.BillingCycle;
        this.MoveInDatePP = this.unitDetail.MoveInDate;
        this.ProrateRent=this.unitDetail.ProrateRent;
        this.TotalSquareFoot = this.unitDetail.TotalSquareFoot;
        this.PaidThruDate = this.commotMethodService.getAPIDateTimeToLocalDatePart(this.unitDetail.PaidThruDate);
        this.PropertyProtectionDate = this.commotMethodService.getAPIDateTimeToLocalDatePart(this.unitDetail.PropertyProtectionDate);
        this.NextBillingDate = this.commotMethodService.getTimeZoneOffSetDate(this.unitDetail.NextBillingDate);
        this.Autopay = this.unitDetail.Autopay || this.unitDetail.ACHPayment || this.unitDetail.DirectDebit ? 'Enabled' : 'Disabled';
        if (this.unitDetail.LatestURCToDate) {
          this.LatestURCToDate = this.unitDetail.LatestURCToDate;
          this.LatestURCToDatePlusOne = this.getTimeZoneOffSetDate(this.LatestURCToDate);
          this.LatestURCToDatePlusOne.setDate(this.LatestURCToDatePlusOne.getDate() + 1);
        }
        if (this.miscellaneousSettings != undefined && this.miscellaneousSettings.DisplayPendingDuesforNextPeriodUnderMonthlyCharges && this.unitDetail.Balance > 0) {
          this.Deposit = (this.unitDetail.BalanceDeposit).toFixed(2);
          this.Rent = (this.unitDetail.BalanceRent + this.unitDetail.Rent).toFixed(2);
          this.Fees = (this.unitDetail.BalanceFees + this.unitDetail.Fees).toFixed(2);
          this.LateandLienAmount = (this.unitDetail.BalanceLateLienCharge + this.unitDetail.LateandLienAmount).toFixed(2);
          this.TaxOnLateandLienAmount = (this.unitDetail.BalanceLateLienChargeTax + this.unitDetail.TaxOnLateandLienAmount).toFixed(2);
          this.Discount = this.unitDetail.Discount.toFixed(2);
          this.Insurance = (this.unitDetail.BalanceInsurance + this.unitDetail.Insurance).toFixed(2);
          this.Tax = (this.unitDetail.BalanceRentTax +
            this.unitDetail.BalanceFeesTax +
            this.unitDetail.BalanceInsuranceTax +
            this.unitDetail.BalanceLateLienChargeTax +
            this.unitDetail.RentalTax +
            this.unitDetail.FeesTax +
            this.unitDetail.InsTax +
            this.unitDetail.TaxOnLateandLienAmount).toFixed(2);
          this.Total = (
            this.unitDetail.Balance +
            this.unitDetail.Rent +
            this.unitDetail.Fees +
            this.unitDetail.Insurance +
            this.unitDetail.TaxOnLateandLienAmount +
            this.unitDetail.RentalTax +
            this.unitDetail.FeesTax +
            this.unitDetail.InsTax +
            this.unitDetail.LateandLienAmount -
            this.unitDetail.Discount).toFixed(2);
          this.TaxTotalPopup = this.Tax;
          this.totalRentTax = (this.unitDetail.RentalTax + this.unitDetail.BalanceRentTax).toFixed(2);
          this.totalFeesTax = (this.unitDetail.FeesTax + this.unitDetail.BalanceFeesTax).toFixed(2);
          this.totalPPTax = (this.unitDetail.InsTax + this.unitDetail.BalanceInsuranceTax).toFixed(2);
        } else {
          this.Deposit = this.unitDetail.BalanceDeposit.toFixed(2);
          this.Rent = this.unitDetail.Rent.toFixed(2);
          this.Fees = this.unitDetail.Fees.toFixed(2);
          this.LateandLienAmount = this.unitDetail.LateandLienAmount.toFixed(2);
          this.TaxOnLateandLienAmount = this.unitDetail.TaxOnLateandLienAmount.toFixed(2);
          this.Discount = this.unitDetail.Discount.toFixed(2);
          this.Insurance = this.unitDetail.Insurance.toFixed(2);
          this.Tax = (this.unitDetail.RentalTax +
            this.unitDetail.FeesTax +
            this.unitDetail.InsTax +
            this.unitDetail.TaxOnLateandLienAmount).toFixed(2);
          this.Total = (this.unitDetail.Rent +
            this.unitDetail.Fees +
            this.unitDetail.Insurance +
            this.unitDetail.TaxOnLateandLienAmount +
            this.unitDetail.RentalTax +
            this.unitDetail.FeesTax +
            this.unitDetail.InsTax +
            this.unitDetail.LateandLienAmount -
            this.unitDetail.Discount).toFixed(2);
          this.TaxTotalPopup = this.Tax;
          this.totalRentTax = (this.unitDetail.RentalTax).toFixed(2);
          this.totalFeesTax = (this.unitDetail.FeesTax).toFixed(2);
          this.totalPPTax = (this.unitDetail.InsTax).toFixed(2);
        }
        this.Balance = this.unitDetail.Balance.toFixed(2);
        this.taxCalc = (parseFloat(this.unitDetail.BalanceDepositTax.toFixed(2)) +
          parseFloat(this.unitDetail.BalanceFeesTax.toFixed(2)) +
          parseFloat(this.unitDetail.BalanceInsuranceTax.toFixed(2)) +
          parseFloat(this.unitDetail.BalanceLateLienChargeTax.toFixed(2)) +
          parseFloat(this.unitDetail.BalanceMerchandiseTax.toFixed(2)) +
          parseFloat(this.unitDetail.BalanceRentTax.toFixed(2))).toFixed(2);
        this.amtDueTotal = (parseFloat(this.unitDetail.BalanceRent.toFixed(2)) +
          parseFloat(this.unitDetail.BalanceInsurance.toFixed(2)) +
          parseFloat(this.unitDetail.BalanceFees.toFixed(2)) +
          parseFloat(this.unitDetail.BalanceLateLienCharge.toFixed(2))
        ).toFixed(2);

        this.makePayment(leaseNo, facilityID, this.unitDetail.UnitId);

        this.loaderIcon = Promise.resolve(false);
        this.effectiveDatesList = this.commotMethodService.getEffectiveDates(new Date(), this.NextBillingDate, this.unitDetail.BillingTypeId, this.unitDetail.BillingCycleId, 1);
        this.stopDatesList = this.commotMethodService.getEffectiveDates(new Date(), this.NextBillingDate, this.unitDetail.BillingTypeId, this.unitDetail.BillingCycleId, 2);
        this.effectiveDatesList.sort((a, b) => a.getTime() - b.getTime());
        this.stopDatesList.sort((a, b) => a.getTime() - b.getTime());
      });

  }

  getTimeZoneOffSetDate(date) {
    let givenDate = new Date(date);
    return new Date(givenDate.getTime() + Math.abs(givenDate.getTimezoneOffset() * 60000));
  }

  getCustomerRentRaiseSettings(facilityId) {
    this.customerService.getCustomerRentRaiseSettings(facilityId).subscribe((response: ICustomerRentRaiseSetttings) => {
      this.rentRaiseSettings = response;
    });
  }

  FeesChargesChanges(data) {
    this.feesChargesList = data;
    if (data.length) {
      if (this.prePaymentPeriod == 0) {
        this.disablePrePay = false;
        this.isPrePay = false;
      }
      data.map((ele) => {
        if (!ele.selected) {
          let index = this.allowanceDataList.findIndex(o => o.Id === ele.FeesAndChargesId && o.AppliedFeeDueID == ele.AppliedFeeDueID
            && o.RecurringFeeId == ele.RecurringFeeId);
          if (index !== -1) {
            this.allowanceDataList.splice(index, 1);
          }
        }
      });
    } else {
      this.customerDuesDetails.TotalFeesDue = 0;
    }
    let chargesObj = this.createPrePaymentObj(this.paymentPrePaidPeriod);
    chargesObj = JSON.parse(JSON.stringify(chargesObj));
    this.getCustomerPrePayAmt(chargesObj);
  }

  //             Property Protection              //

  getCustomerPropertyProtection(leaseNo, facilityId) {
    this.customerService.getCustomerPropertyProtection(leaseNo, facilityId).subscribe((response: ICustomerPropertyProtection[]) => {
      this.CustomerPropertyProtectionList = response;
      const propObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance === true);
      this.initialPPSelected = propObj;
      this.selectedInsuranceId = propObj.Id;
      if (propObj && propObj.Status == EPropertyProtectionStatus.Insured) {
        this.getInsuranceDetails(propObj.InsCompanyId);
        if (propObj.EffectiveDate) {
          propObj.EffectiveDate = this.commotMethodService.getAPIDateTimeToLocalDatePart(propObj.EffectiveDate);
          if (propObj.EffectiveDate > new Date(this.FacilityDate)) {
            propObj['isFutureEffectiveIns'] = true;
          }
        }
      }
      let index = this.CustomerPropertyProtectionList.findIndex(o => o.Id == EPropertyProtectionId.PendingInsurance);
      if (index !== -1) {
        this.CustomerPropertyProtectionList.splice(index, 1);
      }
      if (response) {
        if (!this.miscellaneousSettings && this.data.miscellaneousSettings) {
          this.miscellaneousSettings = this.data.miscellaneousSettings;
        }
        this.CustomerPropertyProtectionList.map((ele) => {
          if (this.miscellaneousSettings.DisplayInsuranceScheme) {
            if (ele.Id == EPropertyProtectionId.None || ele.Id == EPropertyProtectionId.ProofOfInsurance || ele.Id == EPropertyProtectionId.SelfInsurance) {
              ele.Name = ele.Name;
            } else {
              ele.Name = ele.Name + ' - ' + this.currencyPipe.transform(ele.PremiumAmount);
            }
          } else {
            if (ele.Id == EPropertyProtectionId.None || ele.Id == EPropertyProtectionId.ProofOfInsurance || ele.Id == EPropertyProtectionId.SelfInsurance) {
              ele.Name = ele.Name;
            } else {
              ele.Name = ele.CoverageAmount;
            }
          }
          if (ele.Id == EPropertyProtectionId.ProofOfInsurance) {
            ele.ExpiryDate = this.commotMethodService.getAPIDateTimeToLocalDatePart(ele.ExpiryDate);
          }
          ele['isFutureEffectiveIns'] = ele['isFutureEffectiveIns'] ? true : false;
        });
      }
      this.loaderIcon = Promise.resolve(false);

    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  getInsuranceDetails(id: number) {
    this.propertyProtectionservice.GetPropertyDetailsForOp(id).subscribe((res: IPropertyDetails) => {
      this.propertyProtectionSetting = res;
    });
  }

  propertProtectionInit(data) {
    if (data) {
      if (this.NextDayendDate && this.MoveInDatePP) {
        this.PropertyProtectionComponent.isFutureMovein(this.NextDayendDate, this.MoveInDatePP);
      }
      if (this.customerDuesDetails.Dues.Insurance.length) {
        let Insuranceobj = this.customerDuesDetails.Dues.Insurance.pop();
        this.PropertyProtectionComponent.PropertyProtectionForm.patchValue({
          PropertyProtection: Insuranceobj.InsuranceSchemeId,
          DateOption: '1'
        });
        this.PropertyProtectionComponent.initialSelectedInsuranceID = Insuranceobj.InsuranceSchemeId;
        if (Insuranceobj.InsuranceSchemeId == EPropertyProtectionId.ProofOfInsurance) {
          this.PropertyProtectionComponent.PropertyProtectionForm.controls['CompanyName'].enable();
          this.PropertyProtectionComponent.PropertyProtectionForm.controls['PolicyNo'].enable();
          this.PropertyProtectionComponent.setMinMaxExpDate();
        } else {
          this.PropertyProtectionComponent.PropertyProtectionForm.controls['CompanyName'].disable();
          this.PropertyProtectionComponent.PropertyProtectionForm.controls['PolicyNo'].disable();
        }

        if (!this.PropertyProtectionComponent.futureMovedIn) {
          this.PropertyProtectionComponent.PropertyProtectionForm.controls['DateOption'].disable();
          this.PropertyProtectionComponent.PropertyProtectionForm.controls['EffectiveDate'].disable();
        }
      } else if (this.CustomerPropertyProtectionList.length) {
        let propObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance == true);
        if (propObj) {
          let tempDateOption = '1';
          if (propObj.EffectiveDate && propObj.EffectiveDate > new Date(this.FacilityDate)) {
            if (!this.PropertyProtectionComponent.futureMovedIn) {
              tempDateOption = '2';
            } else if ((this.PropertyProtectionComponent.futureMovedIn && (propObj.EffectiveDate > new Date(this.commotMethodService.getFormattedDate(this.MoveInDatePP))))) {
              tempDateOption = '2';
            }
          }
          this.PropertyProtectionComponent.PropertyProtectionForm.patchValue({
            PropertyProtection: propObj.Id,
            DateOption: tempDateOption,
            PolicyNo: propObj.Status == EPropertyProtectionStatus.ProofOfInsurance ? (propObj.InsuranceNumber ? propObj.InsuranceNumber : '') : '',
            CompanyName: propObj.Status == EPropertyProtectionStatus.ProofOfInsurance ? (propObj.CompanyName ? propObj.CompanyName : '') : '',
            ExpiryDate: propObj.Status == EPropertyProtectionStatus.ProofOfInsurance ? (propObj.ExpiryDate ? propObj.ExpiryDate : '') : ''
          });
          this.PropertyProtectionComponent.initialSelectedInsuranceID = propObj.Id;
          if (propObj.Status == EPropertyProtectionStatus.ProofOfInsurance) {
            this.PropertyProtectionComponent.PropertyProtectionForm.controls['CompanyName'].enable();
            this.PropertyProtectionComponent.PropertyProtectionForm.controls['PolicyNo'].enable();
            this.PropertyProtectionComponent.setMinMaxExpDate();
          } else {
            this.PropertyProtectionComponent.PropertyProtectionForm.controls['CompanyName'].disable();
            this.PropertyProtectionComponent.PropertyProtectionForm.controls['PolicyNo'].disable();
          }
          if (propObj.EffectiveDate && propObj.EffectiveDate > new Date(this.FacilityDate) || this.PropertyProtectionComponent.futureMovedIn) {
            propObj.isFutureEffectiveIns = true;
          } else if (propObj.Id != EPropertyProtectionId.ProofOfInsurance) {
            this.PropertyProtectionComponent.PropertyProtectionForm.controls['DateOption'].disable();
            this.PropertyProtectionComponent.PropertyProtectionForm.controls['EffectiveDate'].disable();
          }
        }
      }
    }
  }

  propertyProtectionChanges(data) {
    if (data) {
      this.insuranceDetails = data.propObj;
      if (data.EffectiveDate !== "" || data.EffectiveDate !== null) {
        this.insuranceDetails.EffectiveDate = data.EffectiveDate;
      } else {
        this.insuranceDetails.EffectiveDate = new Date();
      }
      this.insuranceDetails.EffectiveDate = this.commotMethodService.getDateTimeWithoutTimeForApi(this.insuranceDetails.EffectiveDate);
      this.insuranceDetails['InsuranceEffectiveFrom'] = data.InsuranceEffectiveFrom;
      this.insuranceDetails['defaultDate'] = this.FacilityDate;
      this.disablePrePay = true;
      this.errorPropertProtectionModel = data.IsPropObjError ? true : false;
      if (!data.DoNotCallApi) {
        if (this.prePaymentPeriod == 0) {
          this.disablePrePay = false;
          this.isPrePay = false;
        }
        let chargesObj = this.createPrePaymentObj(this.paymentPrePaidPeriod);
        chargesObj = JSON.parse(JSON.stringify(chargesObj));
        this.getCustomerPrePayAmt(chargesObj);
      }
    } else {
      this.insuranceDetails = null;
      this.errorPropertProtectionModel = false;
      let chargesObj = this.createPrePaymentObj(this.paymentPrePaidPeriod);
      chargesObj = JSON.parse(JSON.stringify(chargesObj));
      this.getCustomerPrePayAmt(chargesObj);
    }
  }


  //              Pricing and Promotions                //
  SavePricingAndPromotions(val) {
    let callAPIonPrePayZero = false;
    this.labelPricingPromotionAppliedPD = false;
    this.PDDiscountList = val;
    this.disablePrePay = true;
    if (this.payTillLastPeriod) {
      this.payTillLastPeriod = false;
      this.isPrePayPeriodRefetch = false;
      this.getCustomerPaymentDues(this.unitDetail.LeaseNo, this.unitDetail.FacilityID, this.unitDetail.UnitId);
    }
    if (this.prePaymentPeriod == 0) {
      this.disablePrePay = false;
      this.isPrePay = false;
    }
    for (const el of val) {
      if (el.Selected) {
        this.IsEditPricingPromotion = true;
        if (el.newlyChecked) {
          this.prePayChangeOnDiscount(val, 1);
        }
        break;
      } else {
        this.IsEditPricingPromotion = false;
        if (el.newlyChecked) {
          this.prePayChangeOnDiscount(val, 1);
          callAPIonPrePayZero = true;
        }
      }
    }
    if (this.paymentPrePaidPeriod != 0) {
      let chargesObj = this.createPrePaymentObj(this.prePaymentPeriod);
      chargesObj = JSON.parse(JSON.stringify(chargesObj));
      this.getCustomerPrePayAmt(chargesObj);
    } else if (callAPIonPrePayZero) {
      let chargesObj = this.createPrePaymentObj(this.prePaymentPeriod);
      chargesObj = JSON.parse(JSON.stringify(chargesObj));
      this.getCustomerPrePayAmt(chargesObj);
    } else {
      this.generalService.stopLoaderEmitter.emit(true);
    }

    if (this.allowanceDataList.find(o => o.AllowanceType === 2) && this.allowanceDataList.find(o => o.AllowanceType === 2).Allowance != 0) {
      this.rentPD = this.allowanceDataList.find(o => o.AllowanceType === 2).Amount - (this.allowanceDataList.find(o => o.AllowanceType === 2).Balance).toFixed(2);
      let tempRent = this.rentAllowancePD + this.customerDuesDetails.TotalRentTax;
      let rentcal = this.rentPD / tempRent;
      this.rentPost = rentcal * this.rentAllowancePD;
      this.rentTaxPost = rentcal * this.customerDuesDetails.TotalRentTax;
      this.rentPost = parseFloat(Number(this.rentPost).toFixed(2));
      this.rentTaxPost = parseFloat(Number(this.rentTaxPost).toFixed(2));
      this.rentPost = isNaN(this.rentPost) ? 0 : this.rentPost;
      this.rentTaxPost = isNaN(this.rentTaxPost) ? 0 : this.rentTaxPost;
    } else if (this.allowanceDataList.find(o => o.AllowanceType === 4) && this.allowanceDataList.find(o => o.AllowanceType === 4).Allowance != 0) {
      this.feesPD = this.allowanceDataList.find(o => o.AllowanceType === 4).Amount - (this.allowanceDataList.find(o => o.AllowanceType === 4).Balance).toFixed(2);
      let tempFees = this.feesAllowancePD + this.customerDuesDetails.TotalFeesTax;
      let feescal = this.feesPD / tempFees;
      this.feesPost = feescal * this.feesAllowancePD;
      this.feesTaxPost = feescal * this.customerDuesDetails.TotalFeesTax;
      this.feesPost = parseFloat(Number(this.feesPost).toFixed(2));
      this.feesTaxPost = parseFloat(Number(this.feesTaxPost).toFixed(2));
      this.feesPost = isNaN(this.feesPost) ? 0 : this.feesPost;
      this.feesTaxPost = isNaN(this.feesTaxPost) ? 0 : this.feesTaxPost;
    } else if (this.allowanceDataList.find(o => o.AllowanceType === 3) && this.allowanceDataList.find(o => o.AllowanceType === 3).Allowance != 0) {
      this.propProtPD = this.allowanceDataList.find(o => o.AllowanceType === 3).Amount - (this.allowanceDataList.find(o => o.AllowanceType === 3).Balance).toFixed(2);
      let temppropProt = this.propProtAllowancePD + this.customerDuesDetails.TotalInsuranceTax;
      let propProtPDcal = this.propProtPD / temppropProt;
      this.propProtPDPost = propProtPDcal * this.propProtAllowancePD;
      this.propProtPDTaxPost = propProtPDcal * this.customerDuesDetails.TotalInsuranceTax;
      this.propProtPDPost = parseFloat(Number(this.propProtPDPost).toFixed(2));
      this.propProtPDTaxPost = parseFloat(Number(this.propProtPDTaxPost).toFixed(2));
      this.propProtPDPost = isNaN(this.propProtPDPost) ? 0 : this.propProtPDPost;
      this.propProtPDTaxPost = isNaN(this.propProtPDTaxPost) ? 0 : this.propProtPDTaxPost;
    } else if (this.allowanceDataList.find(o => o.AllowanceType === 5) && this.allowanceDataList.find(o => o.AllowanceType === 5).Allowance != 0) {
      this.merchandisePD = this.allowanceDataList.find(o => o.AllowanceType === 5).Amount - (this.allowanceDataList.find(o => o.AllowanceType === 5).Balance).toFixed(2);
      let tempMerchandisePD = this.merchandiseAllowancePD + this.customerDuesDetails.TotalMerchandiseTax;
      let MerchandisePDcal = this.merchandisePD / tempMerchandisePD;
      this.MerchandisePDPost = MerchandisePDcal * this.merchandiseAllowancePD;
      this.MerchandisePDTaxPost = MerchandisePDcal * this.customerDuesDetails.TotalMerchandiseTax;
      this.MerchandisePDPost = parseFloat(Number(this.MerchandisePDPost).toFixed(2));
      this.MerchandisePDTaxPost = parseFloat(Number(this.MerchandisePDTaxPost).toFixed(2));
      this.MerchandisePDPost = isNaN(this.MerchandisePDPost) ? 0 : this.MerchandisePDPost;
      this.MerchandisePDTaxPost = isNaN(this.MerchandisePDTaxPost) ? 0 : this.MerchandisePDTaxPost;
    } else if (this.allowanceDataList.find(o => o.AllowanceType === 6) && this.allowanceDataList.find(o => o.AllowanceType === 6).Allowance != 0) {
      this.lateAndlienPD = this.allowanceDataList.find(o => o.AllowanceType === 6).Amount - (this.allowanceDataList.find(o => o.AllowanceType === 6).Balance).toFixed(2);
      let tempLateAndlienPD = this.lateAndlienAllowancePD + this.customerDuesDetails.TotalLateLienTax;
      let LateAndlienPDcal = this.lateAndlienPD / tempLateAndlienPD;
      this.LateAndlienPDPost = LateAndlienPDcal * this.lateAndlienAllowancePD;
      this.LateAndlienPDTaxPost = LateAndlienPDcal * this.customerDuesDetails.TotalLateLienTax;
      this.LateAndlienPDPost = parseFloat(Number(this.LateAndlienPDPost).toFixed(2));
      this.LateAndlienPDTaxPost = parseFloat(Number(this.LateAndlienPDTaxPost).toFixed(2));
      this.LateAndlienPDPost = isNaN(this.LateAndlienPDPost) ? 0 : this.LateAndlienPDPost;
      this.LateAndlienPDTaxPost = isNaN(this.LateAndlienPDTaxPost) ? 0 : this.LateAndlienPDTaxPost;
    }
    this.calculateCuatomerDues();
  }

  getFacPaymentSettings(facilityId) {
    this.prospectService.getpaymentSettings(facilityId).subscribe((response) => {
      this.paymentSettings = response;
    });
  }


  //                 Allowance            //

  getFacilityAllowanceItems(facilityId) {
    this.prospectService.getFacilityAllowanceItems(facilityId).subscribe((response: IFacilityAllowanceItemsModel[]) => {
      this.facilityAllowanceItems = response;
      if (this.facilityAllowanceItems.length > 0) {
        this.facilityAllowanceItems.forEach(item => {
          if (item.Type == 583) {
            const limit = this.userGroupData.UserGroupAllowanceItemsLimits.find(ele =>
              ele.AllowanceItemId == item.Id)
            if (limit) {
              if (limit.ValueAmt < item.MaxValue) {
                item.MaxValue = limit.ValueAmt;
              }
            }
          }
        });
      }
    }, err => {
    });
  }


  allowanceChange(objectReceived) {
    let data = objectReceived.Data;
    this.allowanceItemId = objectReceived.AllowanceItemId;
    this.selectedAllowanceItemDetail = this.allowanceItemId == 0 ? null :
      this.facilityAllowanceItems.find(x => (x.Id == this.allowanceItemId));
    this.allowanceError = objectReceived.ErrorIdAllowance
    this.totalAllowance = 0;
    if (data && data.length) {
      this.totalAllowance = data.reduce((sum, ele) => sum + parseFloat(ele.Allowance), 0);
      this.allowanceDataList = data;
      this.calculateCuatomerDues();
      var feelist = [];
      var tempallowancelist = []
      this.allowanceDataList.map(ele => {
        if (ele.AllowanceType == 4) {
          tempallowancelist.push(ele);
        }
      });

      this.feesChargesList.map(ele => {
        let invoiceIndex = tempallowancelist.findIndex(al => al.Id == ele.FeesAndChargesId && al.InvoiceFee == true && al.Allowance > 0);
        if (invoiceIndex != -1) {
          ele['Allowance'] = {
            Allowance: tempallowancelist[invoiceIndex].Allowance
          }
        } else {
          const index = tempallowancelist.findIndex(al => al.Id == ele.FeesAndChargesId && al.RecurringFeeId == ele.RecurringFeeId
            && al.AppliedFeeDueID == ele.AppliedFeeDueID);
          if (index != -1) {
            ele['Allowance'] = {
              Allowance: tempallowancelist[index].Allowance
            }
            tempallowancelist.splice(index, 1);
          } else {
            ele['Allowance'] = {
              Allowance: 0
            }
          }
        }
      });

      this.lateLeinList.forEach((ele) => {
        let allowanceObj = this.allowanceDataList.find(o => o.Id == ele.FeesAndChargesId); //
        if (allowanceObj) {
          ele.Allowance = {
            Allowance: allowanceObj.Allowance
          }
        }
      });
    }

    if (this.prePaymentPeriod == 0) {
      this.disablePrePay = false;
      this.isPrePay = false;
    }
    let modelLedger = this.createPrePaymentObj(this.prePaymentPeriod);
    modelLedger['RentAllowance'] = this.getRentAllowance(this.allowanceDataList, 2);
    modelLedger['FeeAllowance'] = this.getRentAllowance(this.allowanceDataList, 4);
    modelLedger['InsAllowance'] = this.getRentAllowance(this.allowanceDataList, 3);
    modelLedger['DepositAllowance'] = this.getRentAllowance(this.allowanceDataList, 1);
    modelLedger['MerchAllowance'] = this.getRentAllowance(this.allowanceDataList, 5);
    modelLedger['LateLienAllowance'] = this.getRentAllowance(this.allowanceDataList, 6);
    modelLedger['AllowanceList'] = this.allowanceDataList;
    modelLedger['LateLienAllowanceList'] = this.lateLeinList;
    this.getLedgerBreakdown(modelLedger);
  }

  addAllowanceNotes(data) {
    this.allowanceNotes = data;
  }


  //                Payment Distribution                  //
  currencyInputChanged(value, type) {
    this.IsPaymentDistModify = true;
    this.depositAllowancePD = this.allowanceDataList.find(o => o.AllowanceType === 1) && this.allowanceDataList.find(o => o.AllowanceType === 1).Allowance != 0 ? (this.allowanceDataList.find(o => o.AllowanceType === 1).Balance).toFixed(2) : this.customerDuesDetails.TotalDepositDue;
    this.rentAllowancePD = this.customerDuesDetails.TotalRentDue;
    this.feesAllowancePD = this.customerDuesDetails.TotalFeesDue;
    this.propProtAllowancePD = this.customerDuesDetails.TotalInsuranceDue;
    this.merchandiseAllowancePD = this.customerDuesDetails.TotalMerchandiseDue;
    this.lateAndlienAllowancePD = this.customerDuesDetails.TotalLateLienChargeDue;
    let depositAllocated = this.customerDuesDetails.TotalDepositDue;
    let rentAllocated = this.customerDuesDetails.TotalRentDue + this.customerDuesDetails.TotalRentTax;
    let feesAllocated = this.customerDuesDetails.TotalFeesDue + this.customerDuesDetails.TotalFeesTax;
    let propProtAllocated = this.customerDuesDetails.TotalInsuranceDue + this.customerDuesDetails.TotalInsuranceTax;
    let merchandiseAllocated = this.customerDuesDetails.TotalMerchandiseDue + this.customerDuesDetails.TotalMerchandiseTax;
    let latelienAllocated = this.customerDuesDetails.TotalLateLienChargeDue + this.customerDuesDetails.TotalLateLienTax;
    depositAllocated = depositAllocated.toFixed(2)
    rentAllocated = rentAllocated.toFixed(2)
    feesAllocated = feesAllocated.toFixed(2)
    propProtAllocated = propProtAllocated.toFixed(2)
    merchandiseAllocated = merchandiseAllocated.toFixed(2)
    latelienAllocated = latelienAllocated.toFixed(2)

    if (type === 'depositPD') {
      if (depositAllocated < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
        this.depositPDIsEdit = true
      } else {
        this.depositPDIsEdit = false
        this.depositPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
      }
    } else if (type === 'rentPD') {
      if (this.IsEditPricingPromotion) {
        this.templatePDConfirm.show();
      }
      if (this.rentPDlab === parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {

      } else if (this.rentPDlab > parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
      }
      if (this.allowanceDataList.find(o => o.AllowanceType === 2) && this.allowanceDataList.find(o => o.AllowanceType === 2).Allowance != 0) {
        if (((this.allowanceDataList.find(o => o.AllowanceType === 2).Balance).toFixed(2) - this.customerDuesDetails.TotalDiscount) < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          if (this.IsEditPricingPromotion) {
            this.rentPDIsEdit = false
          } else {
            this.rentPDIsEdit = true
          }
        } else {
          this.rentPDIsEdit = false
          this.rentPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          this.rentTaxPosttemp = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2));
          let tempRent = this.rentAllowancePD + this.customerDuesDetails.TotalRentTax;
          let rentcal = this.rentPD / tempRent;
          this.rentPost = rentcal * this.rentAllowancePD;
          this.rentTaxPost = this.rentPD === 0 ? 0 : rentcal * this.customerDuesDetails.TotalRentTax;
          this.rentPost = parseFloat(Number(this.rentPost).toFixed(2));
          this.rentTaxPost = parseFloat(Number(this.rentTaxPost).toFixed(2));
          this.rentPost = isNaN(this.rentPost) ? 0 : this.rentPost;
          this.rentTaxPost = isNaN(this.rentTaxPost) ? 0 : this.rentTaxPost;
        }
      } else {
        let tempRent = this.rentAllowancePD + this.customerDuesDetails.TotalRentTax;

        if ((tempRent - this.customerDuesDetails.TotalDiscount) < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          if (this.IsEditPricingPromotion) {
            this.rentPDIsEdit = false

          } else {
            this.rentPDIsEdit = true
          }
          this.rentPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          this.rentTaxPosttemp = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2));
          let rentcal = this.rentPD / tempRent;
          this.rentPost = rentcal * this.rentAllowancePD;
          this.rentTaxPost = this.rentPD === 0 ? 0 : rentcal * this.customerDuesDetails.TotalRentTax;
          this.rentPost = parseFloat(Number(this.rentPost).toFixed(2));
          this.rentTaxPost = parseFloat(Number(this.rentTaxPost).toFixed(2));
          this.rentPost = isNaN(this.rentPost) ? 0 : this.rentPost;
          this.rentTaxPost = isNaN(this.rentTaxPost) ? 0 : this.rentTaxPost;
        } else {
          this.rentPDIsEdit = false
          this.rentPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          this.rentTaxPosttemp = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2));
          let taxincdisrent = (tempRent - (this.customerDuesDetails.TotalDiscount == null ? 0 : this.customerDuesDetails.TotalDiscount));
          taxincdisrent = taxincdisrent > 0 ? taxincdisrent : tempRent;
          let rentcal = this.rentPD / taxincdisrent;
          let discountedRent = (this.rentAllowancePD - (this.customerDuesDetails.TotalDiscount == null ? 0 : this.customerDuesDetails.TotalDiscount));
          discountedRent = discountedRent < 0 ? 0 : discountedRent;
          this.rentPost = rentcal * discountedRent;
          this.rentTaxPost = this.rentPD === 0 ? 0 : rentcal * this.customerDuesDetails.TotalRentTax;
          this.rentPost = parseFloat(Number(this.rentPost).toFixed(2));
          this.rentTaxPost = parseFloat(Number(this.rentTaxPost).toFixed(2));
          this.rentPost = isNaN(this.rentPost) ? 0 : this.rentPost;
          this.rentTaxPost = isNaN(this.rentTaxPost) ? 0 : this.rentTaxPost;
        }
      }
    } else if (type === 'feesPD') {
      if (this.allowanceDataList.find(o => o.AllowanceType === 4) && this.allowanceDataList.find(o => o.AllowanceType === 4).Allowance != 0) {
        if ((this.allowanceDataList.find(o => o.AllowanceType === 4).Balance).toFixed(2) < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          this.feesPDIsEdit = true
        } else {
          this.feesPDIsEdit = false
          this.feesPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          let tempFees = this.feesAllowancePD + this.customerDuesDetails.TotalFeesTax;
          let feescal = this.feesPD / tempFees;
          this.feesPost = feescal * this.feesAllowancePD;
          this.feesTaxPost = feescal * this.customerDuesDetails.TotalFeesTax;
          this.feesPost = parseFloat(Number(this.feesPost).toFixed(2));
          this.feesTaxPost = parseFloat(Number(this.feesTaxPost).toFixed(2));
          this.feesPost = isNaN(this.feesPost) ? 0 : this.feesPost;
          this.feesTaxPost = isNaN(this.feesTaxPost) ? 0 : this.feesTaxPost;
        }
      } else {
        let tempFees = this.feesAllowancePD + this.customerDuesDetails.TotalFeesTax;
        if (tempFees < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          this.feesPDIsEdit = true
        } else {
          this.feesPDIsEdit = false
          this.feesPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          let feescal = this.feesPD / tempFees;
          this.feesPost = feescal * this.feesAllowancePD;
          this.feesTaxPost = feescal * this.customerDuesDetails.TotalFeesTax;
          this.feesPost = parseFloat(Number(this.feesPost).toFixed(2));
          this.feesTaxPost = parseFloat(Number(this.feesTaxPost).toFixed(2));
          this.feesPost = isNaN(this.feesPost) ? 0 : this.feesPost;
          this.feesTaxPost = isNaN(this.feesTaxPost) ? 0 : this.feesTaxPost;
        }
      }
    } else if (type === 'propProtPD') {
      if (this.autoEnrolmentAutoEnrollPPPartialPayment && value < this.propProtPD) {
        this.show_PartialPaymentPopup=true;
      }
      if (this.allowanceDataList.find(o => o.AllowanceType === 3) && this.allowanceDataList.find(o => o.AllowanceType === 3).Allowance != 0) {
        if ((this.allowanceDataList.find(o => o.AllowanceType === 3).Balance).toFixed(2) < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          this.propProtPDIsEdit = true
        } else {
          this.propProtPDIsEdit = false
          this.propProtPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          let temppropProt = this.propProtAllowancePD + this.customerDuesDetails.TotalInsuranceTax;
          let propProtPDcal = this.propProtPD / temppropProt;
          this.propProtPDPost = propProtPDcal * this.propProtAllowancePD;
          this.propProtPDTaxPost = propProtPDcal * this.customerDuesDetails.TotalInsuranceTax;
          this.propProtPDPost = parseFloat(Number(this.propProtPDPost).toFixed(2));
          this.propProtPDTaxPost = parseFloat(Number(this.propProtPDTaxPost).toFixed(2));
          this.propProtPDPost = isNaN(this.propProtPDPost) ? 0 : this.propProtPDPost;
          this.propProtPDTaxPost = isNaN(this.propProtPDTaxPost) ? 0 : this.propProtPDTaxPost;
        }
      } else {
        let temppropProt = this.propProtAllowancePD + this.customerDuesDetails.TotalInsuranceTax;
        if (temppropProt < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          this.propProtPDIsEdit = true
        } else {
          this.propProtPDIsEdit = false
          this.propProtPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          let propProtPDcal = this.propProtPD / temppropProt;
          this.propProtPDPost = propProtPDcal * this.propProtAllowancePD;
          this.propProtPDTaxPost = propProtPDcal * this.customerDuesDetails.TotalInsuranceTax;
          this.propProtPDPost = parseFloat(Number(this.propProtPDPost).toFixed(2));
          this.propProtPDTaxPost = parseFloat(Number(this.propProtPDTaxPost).toFixed(2));
          this.propProtPDPost = isNaN(this.propProtPDPost) ? 0 : this.propProtPDPost;
          this.propProtPDTaxPost = isNaN(this.propProtPDTaxPost) ? 0 : this.propProtPDTaxPost;
        }
      }
    } else if (type === 'merchandisePD') {
      if (this.allowanceDataList.find(o => o.AllowanceType === 5) && this.allowanceDataList.find(o => o.AllowanceType === 5).Allowance != 0) {
        if ((this.allowanceDataList.find(o => o.AllowanceType === 5).Balance).toFixed(2) < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          this.merchandisePDIsEdit = true
        } else {
          this.merchandisePDIsEdit = false
          this.merchandisePD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          let tempMerchandisePD = this.merchandiseAllowancePD + this.customerDuesDetails.TotalMerchandiseTax;
          let MerchandisePDcal = this.merchandisePD / tempMerchandisePD;
          this.MerchandisePDPost = MerchandisePDcal * this.merchandiseAllowancePD;
          this.MerchandisePDTaxPost = MerchandisePDcal * this.customerDuesDetails.TotalMerchandiseTax;
          this.MerchandisePDPost = parseFloat(Number(this.MerchandisePDPost).toFixed(2));
          this.MerchandisePDTaxPost = parseFloat(Number(this.MerchandisePDTaxPost).toFixed(2));
          this.MerchandisePDPost = isNaN(this.MerchandisePDPost) ? 0 : this.MerchandisePDPost;
          this.MerchandisePDTaxPost = isNaN(this.MerchandisePDTaxPost) ? 0 : this.MerchandisePDTaxPost;
        }
      } else {
        let tempMerchandisePD = this.merchandiseAllowancePD + this.customerDuesDetails.TotalMerchandiseTax;
        if (tempMerchandisePD < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          this.merchandisePDIsEdit = true
        } else {
          this.merchandisePDIsEdit = false
          this.merchandisePD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          let MerchandisePDcal = this.merchandisePD / tempMerchandisePD;
          this.MerchandisePDPost = MerchandisePDcal * this.merchandiseAllowancePD;
          this.MerchandisePDTaxPost = MerchandisePDcal * this.customerDuesDetails.TotalMerchandiseTax;
          this.MerchandisePDPost = parseFloat(Number(this.MerchandisePDPost).toFixed(2));
          this.MerchandisePDTaxPost = parseFloat(Number(this.MerchandisePDTaxPost).toFixed(2));
          this.MerchandisePDPost = isNaN(this.MerchandisePDPost) ? 0 : this.MerchandisePDPost;
          this.MerchandisePDTaxPost = isNaN(this.MerchandisePDTaxPost) ? 0 : this.MerchandisePDTaxPost;
        }
      }
    } else if (type === 'lateAndlienPD') {
      if (this.allowanceDataList.find(o => o.AllowanceType === 6) && this.allowanceDataList.find(o => o.AllowanceType === 6).Allowance != 0) {
        if ((this.allowanceDataList.find(o => o.AllowanceType === 6).Balance).toFixed(2) < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          this.lateAndlienPDIsEdit = true
        } else {
          this.lateAndlienPDIsEdit = false
          this.lateAndlienPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          let tempLateAndlienPD = this.lateAndlienAllowancePD + this.customerDuesDetails.TotalLateLienTax;
          let LateAndlienPDcal = this.lateAndlienPD / tempLateAndlienPD;
          this.LateAndlienPDPost = LateAndlienPDcal * this.lateAndlienAllowancePD;
          this.LateAndlienPDTaxPost = LateAndlienPDcal * this.customerDuesDetails.TotalLateLienTax;
          this.LateAndlienPDPost = parseFloat(Number(this.LateAndlienPDPost).toFixed(2));
          this.LateAndlienPDTaxPost = parseFloat(Number(this.LateAndlienPDTaxPost).toFixed(2));
          this.LateAndlienPDPost = isNaN(this.LateAndlienPDPost) ? 0 : this.LateAndlienPDPost;
          this.LateAndlienPDTaxPost = isNaN(this.LateAndlienPDTaxPost) ? 0 : this.LateAndlienPDTaxPost;
        }
      } else {
        let tempLateAndlienPD = this.lateAndlienAllowancePD + this.customerDuesDetails.TotalLateLienTax;
        if (tempLateAndlienPD < parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))) {
          this.lateAndlienPDIsEdit = true
        } else {
          this.lateAndlienPDIsEdit = false
          this.lateAndlienPD = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2))
          let LateAndlienPDcal = this.lateAndlienPD / tempLateAndlienPD;
          this.LateAndlienPDPost = LateAndlienPDcal * this.lateAndlienAllowancePD;
          this.LateAndlienPDTaxPost = LateAndlienPDcal * this.customerDuesDetails.TotalLateLienTax;
          this.LateAndlienPDPost = parseFloat(Number(this.LateAndlienPDPost).toFixed(2));
          this.LateAndlienPDTaxPost = parseFloat(Number(this.LateAndlienPDTaxPost).toFixed(2));
          this.LateAndlienPDPost = isNaN(this.LateAndlienPDPost) ? 0 : this.LateAndlienPDPost;
          this.LateAndlienPDTaxPost = isNaN(this.LateAndlienPDTaxPost) ? 0 : this.LateAndlienPDTaxPost;
        }
      }
    }
    this.depositPD = this.depositPD != undefined && this.depositPD != 0 ? this.depositPD : this.depositAllowancePD;
    this.rentPost = this.rentPost != undefined && this.rentPost != 0 ? this.rentPost : this.rentAllowancePD;
    this.rentTaxPost = this.rentTaxPost != undefined && this.rentTaxPost != 0 ? this.rentTaxPost : this.customerDuesDetails.TotalRentTax;
    this.rentTaxPost = this.rentTaxPosttemp == 0 ? 0 : this.rentTaxPost;
    this.feesPost = this.feesPost != undefined && this.feesPost != 0 ? this.feesPost : this.feesAllowancePD;
    this.feesTaxPost = this.feesTaxPost != undefined && this.feesTaxPost != 0 ? this.feesTaxPost : this.customerDuesDetails.TotalFeesTax;
    this.propProtPDPost = this.propProtPDPost != undefined && this.propProtPDPost != 0 ? this.propProtPDPost : this.propProtAllowancePD;
    this.propProtPDTaxPost = this.propProtPDTaxPost != undefined && this.propProtPDTaxPost != 0 ? this.propProtPDTaxPost : this.customerDuesDetails.TotalInsuranceTax;
    this.MerchandisePDPost = this.MerchandisePDPost != undefined && this.MerchandisePDPost != 0 ? this.MerchandisePDPost : this.merchandiseAllowancePD;
    this.MerchandisePDTaxPost = this.MerchandisePDTaxPost != undefined && this.MerchandisePDTaxPost != 0 ? this.MerchandisePDTaxPost : this.customerDuesDetails.TotalMerchandiseTax;
    this.LateAndlienPDPost = this.LateAndlienPDPost != undefined && this.LateAndlienPDPost != 0 ? this.LateAndlienPDPost : this.lateAndlienAllowancePD;
    this.LateAndlienPDTaxPost = this.LateAndlienPDTaxPost != undefined && this.LateAndlienPDTaxPost != 0 ? this.LateAndlienPDTaxPost : this.customerDuesDetails.TotalLateLienTax;
    this.totalPaymentDist = this.depositPD + this.rentPost + this.rentTaxPost + this.feesPost + this.feesTaxPost + this.propProtPDPost + this.propProtPDTaxPost + this.MerchandisePDPost + this.MerchandisePDTaxPost + this.LateAndlienPDPost + this.LateAndlienPDTaxPost;
    this.totalPD = (this.depositPD + this.rentPD + this.feesPD + this.propProtPD + this.merchandisePD + this.lateAndlienPD);
    this.totalPaymentDist = this.totalPD;
    var num = parseFloat(Number(String(value).replace(/[$,]/g, "")).toFixed(2));
    return Number(num);
  }


  getDayEndCompletedDate(facilityId) {
    this.generalService.getDayEndCompletedDate(facilityId).subscribe((response) => {
      if (response) {
        let FacilityDate = this.commotMethodService.getFormattedDate(response.FacilityDateTime);
        if (response.DayendDate && response.NextDayendDate) {
          let dayEndDate = this.commotMethodService.getFormattedDate(response.DayendDate);
          this.NextDayendDate = response.NextDayendDate;
          if (new Date(FacilityDate) > new Date(dayEndDate)) {
            this.FacilityDate = this.commotMethodService.getFormattedDate(response.FacilityDateTime);
          } else {
            this.FacilityDate = this.commotMethodService.getFormattedDate(response.NextDayendDate);
          }
        } else {
          this.NextDayendDate = response.FacilityDateTime;
        }
        this.FacilityDate = new Date(this.FacilityDate);
      }
    });
  }

  getCustomerFacilityMoveInSettings(facilityId) {
    this.customerService.getCustomerMoveInSettings(facilityId).subscribe((response: ICustomerMoveInSettings) => {
      this.facilityMoveInSettings = response;
    });
  }

  //              Partial Payment                   //
  openPartialPayment() {
    this.SetMandatoryFieldPartialPay();
    this.PartialPaymentModal.show();
  }

  SetMandatoryFieldPartialPay() {
    this.loaderIcon = Promise.resolve(true);
    this.generalService.GetMandatoryFieldsById(this.facilityID, 154)
      .subscribe((response: IGetPermissionMandatoryField) => {
        var data = response;
        if (data.Name == this.componentName && data.Form.Name != undefined) {
          if (data.Form.ListOfProperties.length != 0) {
            data.Form.ListOfProperties.forEach(field => {
              let name = `m${field.Name}`;
              if (field.Required) {
                this.partialPayForm.form.get(name).setValidators([Validators.required]);
              } else {
                this.partialPayForm.form.get(name).setValidators(null);
              }
              this.partialPayForm.form.updateValueAndValidity();
              this.partialPayForm.reset();
            });
          }
        }
        this.loaderIcon = Promise.resolve(false);
      })
  }

  checkFeesChargesDisable() {
    const indexError = this.feesChargesList.findIndex(fee => (fee.IsError == true));
    if (indexError != -1) {
      return true;
    }
    return false;
  }

  checkFeesChargesNotesRequired() {
    const index = this.feesChargesList.findIndex((ele) => ele.Stopped && ((ele.Notes && ele.Notes.trim() === '') || !ele.Notes));
    if (index != -1) {
      return true;
    }
    return false;
  }

  makePayNow(data) {
    if (this.autoEnrolmentfornopayment && ((this.totalPD != 0 && this.propProtPD == 0 && this.allowanceDataList.find(o => o.AllowanceType === 3) && this.allowanceDataList.find(o => o.AllowanceType === 3).Allowance == 0))) {
      this.show_zeroPaymentPopup = true;
      this.isfromMakePayment = true;
    }
    else {
      this.addUnitToCart();
      this.emitMakePay.emit(data);
    }

  }

  addUnitToCart() {
    if (this.autoEnrolmentfornopayment && ((this.totalPD != 0 && this.propProtPD == 0 && this.allowanceDataList.find(o => o.AllowanceType === 3) && this.allowanceDataList.find(o => o.AllowanceType === 3).Allowance == 0))) {
      this.show_zeroPaymentPopup = true;
    }
    else {
    this.IsPaymentDist = (this.PaymentDistributionSection && this.IsPaymentDistModify) || this.payTillLastPeriod ? true : false;
      this.cartItemsList = [];
      let unitObj = this.customerDashboardDetails.find(o => o.LeaseNo === this.unitDetail.LeaseNo && o.FacilityID == this.unitDetail.FacilityID);
      if (unitObj) {
        if (this.paymentSettings) {
          if (this.paymentSettings.NSFCheckLimit == 0) {
            this.customerDuesDetails['DonotAcceptCheck'] = false;
          } else {
            this.customerDuesDetails['DonotAcceptCheck'] = false;
          }
        } else {
          this.customerDuesDetails['DonotAcceptCheck'] = false;
        }

        if (this.DelinquentDonotAcceptCheck && this.getDelinquentUnitDays() >= this.DelinquentCheckCount) {
          this.customerDuesDetails['DonotAcceptCheck'] = true;
        }
        if (this.requireFullPaymentDelinquent && this.getDelinquentUnitDays() >= this.requireFullPaymentDelinquentCount && this.unitDetail.LeaseId !== ELOV_RentalStatus['Moved Out']) {
          this.customerDuesDetails['requireFullPayment'] = true;
        }
        let tempFeesList = [];
        tempFeesList = JSON.parse(JSON.stringify(this.feesChargesList));
        tempFeesList.map(fee => {
          fee.EffectiveDate = this.commotMethodService.getDateTimeWithoutTimeForApi(fee.EffectiveDate);
          fee.StopDate = this.commotMethodService.getDateTimeWithoutTimeForApi(fee.StopDate);
        });
        this.feesChargesList = [];// Clearing the Applied fee from the list once added to the Cart.
        this.customerDuesDetails['UnitDetails'] = unitObj;
        this.customerDuesDetails['CartItemType'] = 1;
        this.customerDuesDetails['LeaseIdPD'] = this.unitDetail.LeaseId;
        this.customerDuesDetails['UnitId'] = this.unitDetail.UnitId;
        this.customerDuesDetails['PrePayPeriods'] = this.prePaymentPeriod;
        this.customerDuesDetails['LeaseNo'] = this.unitDetail.LeaseNo;
        this.customerDuesDetails['AllowanceList'] = this.allowanceDataList;
        this.customerDuesDetails['FeesChargesList'] = tempFeesList.filter((ele) => ele.FeesAndChargesId !== 0);
        this.customerDuesDetails['InsuranceDetails'] = this.insuranceDetails;
        this.customerDuesDetails['propertyProtectionSetting'] = this.propertyProtectionSetting;
        this.customerDuesDetails['AppliedDiscountList'] = this.customerDiscountList;
        this.customerDuesDetails['allowanceNotes'] = this.allowanceNotes;
        this.customerDuesDetails['allowanceItemId'] = this.allowanceItemId;
        this.customerDuesDetails['LateLienAllowanceList'] = this.lateLeinList;
        this.customerDuesDetails['PaymentNote'] = this.makePaymentNotes != undefined ? this.makePaymentNotes : '';
        this.customerDuesDetails['IsPaymentDist'] = this.IsPaymentDist;
        this.customerDuesDetails['IsPaymentDistrDiscountisApplied'] = this.IsPaymentDistrDiscountisApplied;
        this.customerDuesDetails['totalCustomerDues'] = this.IsPaymentDist == true ? parseFloat(Number(this.totalPaymentDist).toFixed(2)) :
          this.isSaveAllowance ? 0 : this.totalCustomerDues;
        this.customerDuesDetails['totalCustomerDuesWithoutPD'] = this.isSaveAllowance ? 0 : this.totalCustomerDues;
        this.customerDuesDetails['depositPD'] = this.IsPaymentDist == true ? this.depositPD : 0;
        this.customerDuesDetails['rentPD'] = this.IsPaymentDist == true ? (this.rentPD == 0 ? 0 : this.rentPost) : 0;
        this.customerDuesDetails['feesPD'] = this.IsPaymentDist == true ? (this.feesPD == 0 ? 0 : this.feesPost) : 0;
        this.customerDuesDetails['propProtPD'] = this.IsPaymentDist == true ? (this.propProtPD == 0 ? 0 : this.propProtPDPost) : 0;
        this.customerDuesDetails['merchandisePD'] = this.IsPaymentDist == true ? (this.merchandisePD == 0 ? 0 : this.MerchandisePDPost) : 0;
        this.customerDuesDetails['lateAndlienPD'] = this.IsPaymentDist == true ? (this.lateAndlienPD == 0 ? 0 : this.LateAndlienPDPost) : 0;
        this.customerDuesDetails['rentTaxPD'] = this.IsPaymentDist == true ? (this.rentPD == 0 ? 0 : this.rentTaxPost) : 0;
        this.customerDuesDetails['feesTaxPD'] = this.IsPaymentDist == true ? (this.feesPD == 0 ? 0 : this.feesTaxPost) : 0;
        this.customerDuesDetails['propProtTaxPD'] = this.IsPaymentDist == true ? (this.propProtPD == 0 ? 0 : this.propProtPDTaxPost) : 0;
        this.customerDuesDetails['merchandiseTaxPD'] = this.IsPaymentDist == true ? (this.merchandisePD == 0 ? 0 : this.MerchandisePDTaxPost) : 0;
        this.customerDuesDetails['lateAndlienTaxPD'] = this.IsPaymentDist == true ? (this.lateAndlienPD == 0 ? 0 : this.LateAndlienPDTaxPost) : 0;
        this.customerDuesDetails['totalCustomerDuesTax'] = this.isSaveAllowance ? 0 : (this.totalCustomerDuesTax || 0);
        this.customerDuesDetails['initialPPSelected'] = this.initialPPSelected ? this.initialPPSelected : null;
        this.customerDuesDetails['currentPeriodTotal'] = this.currentPeriodTotal;
        this.customerDuesDetails['isPaymentDistribution'] = this.IsPaymentDist;
        this.customerDuesDetails['isSaveAllowance'] = this.isSaveAllowance;
        this.cartItemsList.push(this.customerDuesDetails);
        this.emitCartItems.emit(this.cartItemsList);
      }
      this.prePaymentPeriod = 0;
      if (!this.isSaveAllowance) {
        this.PaymentDetailsModal.hide();
      } else {
        this.loaderIcon = Promise.resolve(true);
      }
    }

  }

  getDelinquentUnitDays() {
    let dueDate = 0;
    if (this.customerDuesDetails.Dues.Rent.length) {
      if (this.unitDetail.PaidThruDate != null) {
        this.DelinquentStageStartDate = this.unitDetail.PaidThruDate
      }
      else {
        let fromDate = new Date(this.unitDetail.MoveInDate);
        fromDate.setDate(fromDate.getDate() - 1);
        this.DelinquentStageStartDate = fromDate;
      }
      let todaysDate = this.datepipe.transform(this.FacilityDate, 'MM/dd/yyyy');
      dueDate = this.commotMethodService.dateDiff(new Date(this.DelinquentStageStartDate), new Date(todaysDate));
    }
    return dueDate;
  }

  mapFacilityLateAndLienSetting(res, facId) {
    this.DelinquentDonotAcceptCheck = res.DonotAcceptCheckPayment;
    this.requireFullPaymentDelinquent = res.RequireFullPayment;
    this.AllowPartialPayTillPreviousPeriod = res.AllowPartialPayTillPreviousPeriod;
    if (res.DonotAcceptCheckPayment) {
      this.DelinquentCheckCount = res.CheckPaymentDelinquentDays;
    }
    if (res.RequireFullPayment) {
      this.requireFullPaymentDelinquentCount = res.FullPaymentDelinquentDays;
    }
    if (this.AllowPartialPayTillPreviousPeriod) {
      this.DaysAfterRentChargeToAllowPartialPay = res.DaysAfterRentChargeToAllowPartialPay;
    }
  }

  getLateAndLienSettings(facId) {
    this.makePaymentService.getLateAndLienSettings(facId).subscribe(res => {
      if (res) {
        this.mapFacilityLateAndLienSetting(res, facId);
      }
    });
  }

  OnConfirmPDAmt(confirm) {
    let tempTotalRentDue = this.customerDuesDetails.TotalRentDue;
    let temptotalCustomerDues = this.totalCustomerDues;
    let temptotalCustomerDuesTax = this.totalCustomerDuesTax;
    if (confirm === "Yes") {
      if (this.rentPDlab < this.rentPD) {
        this.rentPDIsEdit = true;
      } else {
        this.rentPDIsEdit = false;
      }
      this.IsPaymentDistrDiscountisApplied = true;
      this.labelPricingPromotionAppliedPD = true;
      this.customerDuesDetails.TotalRentDue = this.rentPost;
      this.totalPaymentDist = this.totalPaymentDist - this.customerDuesDetails.TotalInsuranceTax;
      this.totalCustomerDues = this.totalPaymentDist;
      this.totalCustomerDuesTax = this.rentTaxPost + this.feesTaxPost + this.propProtPDTaxPost + this.MerchandisePDTaxPost + this.LateAndlienPDTaxPost;
      if (this.prePaymentPeriod == 0) {
        this.currentPeriodTotal = this.totalCustomerDues;
      }
      this.templatePDConfirm.hide();
    } else if (confirm === "No") {
      this.labelPricingPromotionAppliedPD = false;
      this.IsPaymentDistrDiscountisApplied = false;
      this.customerDuesDetails.TotalRentDue = tempTotalRentDue;
      this.totalCustomerDues = temptotalCustomerDues;
      this.totalCustomerDuesTax = temptotalCustomerDuesTax;
      this.PaymentDistributionSection = false;
      if (this.prePaymentPeriod == 0) {
        this.currentPeriodTotal = this.totalCustomerDues;
      }
      this.templatePDConfirm.hide();
    }
  }

  openPartialPayConfirm(template: TemplateRef<any>) {
    if (this.partialPayForm.touched) {
      this.modalRefConfirm = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    } else {
      this.partialPayForm.reset();
      this.PartialPaymentModal.hide();
    }
  }

  isRequired(control) {
    if (control != null) {
      if (this.partialPayForm.form.get(control).validator !== null) {
        const validator = this.partialPayForm.form.get(control).validator({} as AbstractControl);
        return validator && validator.required ? true : false;
      }
      else {
        return false
      }
    }
  }

  transformAmount(element) {
    this.amtPartialPayment = this.currencyPipe.transform(this.amtPartialPayment, '$');
    element.target.value = this.amtPartialPayment;
  }

  SavePartialPaymentReturn() {
    this.amtPartialPayment = parseFloat(this.amtPartialPayment.slice(1))
    if (this.NotesPartialPayment != '') {
      let pprNotesobj = {
        NotesId: 0,
        LeaseNo: this.LeaseNo,
        FacilityId: this.facilityID,
        ReservationNumber: null,
        ReservationFacilityId: null,
        InquiryNumber: null,
        InquiryFacilityId: null,
        InquiryNotesFacilityId: null,
        FollowUpId: null,
        NotesDate: new Date(),
        Text: this.NotesPartialPayment,
        CustomerNotes: true,
        PriorityNote: false,
        CollectionCall: false,
        PaymentReceiptId: null,
        DisplayAlert: false,
        UnitNo: this.unitDetail.UnitNo,
        TransactionTypeId: 0,
        Creator: null
      };
      this.saveNotesApi(pprNotesobj);
    }
    this.loaderIcon = Promise.resolve(true);
    if (this.amtPartialPayment != 0 && this.NotesPartialPayment != '') {
      this.customerService.SavePartialPaymentReturn(this.LeaseNo, this.facilityID, this.amtPartialPayment, this.NotesPartialPayment).subscribe((response: any) => {
        if (response.Success == true) {
          this.PartialPaymentModal.hide();
          this.emitPartialPayReturn.emit(true);
          this.closemakePay();
          this.toaster.success('Partial Payment Return saved successfully', 'Success', this.toasterConfig);
          this.documentView = true;
        } else {
          this.toaster.error('Failed to Partial Payment Return', 'Failure', this.toasterConfig);
        }
        this.loaderIcon = Promise.resolve(false);
      })
    }
  }

  saveNotesApi(obj) {
    this.loaderIcon = Promise.resolve(true);
    this.prospectService.SaveNotes(obj).subscribe((response: any) => {
      if (response.Success) {
        this.toaster.success('Notes Saved Successfully', 'Success', this.toasterConfig);
        if (this.modalRef != undefined) {
          this.modalRef.hide();
        }
        this.prioirity = false;
        this.loaderIcon = Promise.resolve(false);
        this.FingerprintpopupComponent.resetFingerprintOrigin();
      } else {
        this.loaderIcon = Promise.resolve(false);
      }
    },
      (err: any) => {
        this.loaderIcon = Promise.resolve(false);
      });
  }

  cancelPartialPayModal() {
    if (this.partialPayForm.touched) {
      this.partialPayForm.reset();
      this.modalRefConfirm.hide();
      this.PartialPaymentModal.hide();
    } else {
      this.PartialPaymentModal.hide();
      this.partialPayForm.reset();
    }
  }

  disablePayNow() {
    let checkAppliedFeeStopped = false;
    if (this.feesChargesList.length > 0) {
      checkAppliedFeeStopped = this.feesChargesList.find(fee => (fee.Stopped && fee.AppliedFee)) ? true : false;
    }
    if ((this.totalCustomerDues == 0 && this.totalAllowance == 0 && !checkAppliedFeeStopped) || this.depositPDIsEdit || this.rentPDIsEdit || this.feesPDIsEdit || this.propProtPDIsEdit
      || this.merchandisePDIsEdit || this.lateAndlienPDIsEdit || (this.totalAllowance != 0 && this.allowanceNotes === '' || this.totalAllowance === 0 && this.allowanceNotes != '')) {
      return true;
    }
    return false;
  }

  disableAddToCard() {
    let checkAppliedFeeStopped = false;
    if (this.feesChargesList.length > 0) {
      checkAppliedFeeStopped = this.feesChargesList.find(fee => (fee.Stopped && fee.AppliedFee)) ? true : false;
    }
    if ((this.totalCustomerDues == 0 && this.totalAllowance == 0 && this.customerDuesDetails.TotalRentDue == 0 && !checkAppliedFeeStopped) || this.depositPDIsEdit || this.rentPDIsEdit ||
      this.feesPDIsEdit || this.propProtPDIsEdit || this.merchandisePDIsEdit || this.lateAndlienPDIsEdit || (this.totalAllowance != 0 && this.allowanceNotes === '' || this.totalAllowance === 0 && this.allowanceNotes != '')) {
      return true;
    }
    return false;
  }

  onOpenMakePayment() {
    this.insuranceDetails=null;
    this.clearMakePaymentRecords();
    this.getLateAndLienSettings(this.facilityID);
    this.getUnitDetail(this.tenantId, this.LeaseNo, this.facilityID);
    this.getBasicInfo(this.facilityID, this.tenantId);
  }

  getLettersByTemplates() {
    this.loaderIcon = Promise.resolve(true);
    this.prospectService.getLettersByTransactionType(this.unitDetail.FacilityID, 2).subscribe((response: any) => {
      if (response[0]) {
        this.LettersByTemplates = response.filter(e => e.TemplateId === ELetterAndNoticesTemplates.Partial_Payment_Returned_Letter);
        if ((this.unitDetail.LeaseId === 323 || this.unitDetail.LeaseId === 324 || this.unitDetail.LeaseId === 325 || this.unitDetail.LeaseId === 326) && this.unitDetail.Balance > 0) {
          this.partialPayReturn = this.totalCustomerDues <= 0 ? false : true;
        }
      } else if (this.LettersByTemplates == undefined) {
        this.partialPayReturn = false;
      }
      if (this.LettersByTemplates && this.LettersByTemplates.length == 0) {
        this.partialPayReturn = false;
      }
      this.loaderIcon = Promise.resolve(false);
    });
  }

  clearMakePaymentRecords() {
    this.feesAndChargesDataGrid = [];
    this.allowanceDataList = [];
    this.feesSection = false;
    this.AllowanceSection = false;
    this.propertyProtectionSection = false;
    this.PricingPromotionsSection = false;
    this.prePaymentPeriod = 0;
    this.makePaymentNotes = '';
  }

  validateSaveAllowance() {
    this.isSaveAllowance = true;
    if (this.autoEnrolmentfornopayment && ((this.allowanceDataList.find(o => o.AllowanceType === 3) && this.allowanceDataList.find(o => o.AllowanceType === 3).Allowance == 0))) {
      this.show_zeroPaymentPopup = true;
      this.isfromMakePayment = true;
    }else if (this.autoEnrolmentAutoEnrollPPPartialPayment && this.allowanceDataList && (this.allowanceDataList.find(o => o.AllowanceType === 3).Balance != 0)){
      this.isfromMakePayment = true;
      this.show_PartialPaymentPopup = true;
    }  
    else {
      if (this.miscellaneousSettings && this.miscellaneousSettings.UserAuthenticationforFinancial) {
        this.FingerprintpopupComponent.openFingerprintModal();
        if (this.fingerPrintInitService) {
          this.fingerPrintInitService.startCapture();
          this.fingerPrintInitService.fingerPrintService.moduleType = 3;
          this.fingerPrintInitService.currrentModule = 2;
        }
      } else {
        this.makePayNow(2);
      }
    }

  }

  getCustomerInvoiceSettings(leaseNo, facilityId) {
    this.customerService.getCustomerInvoiceSettings(leaseNo, facilityId).subscribe((response: any) => {
      this.invoiceSettings = response;
      this.loaderIcon = Promise.resolve(false);
    });
  }

  getBasicInfo(facilityID: number, tenantId: number) {
    this.customerService.GetCustomerRentalUnitsInfoDetails(facilityID, tenantId).subscribe((response: ICustomerRentalStatusList[]) => {
      let arr = [];
      arr = response;
      if (arr.length) {
        this.customerDashboardDetails = response;
      }
    });
  }

  removeFromCart(val) {
    this.cartItemsList = val;
  }

  resetData(eve) {
    this.allowanceNotes = '';
    this.allowanceItemId = 0;
    this.allowanceError = 0;
    this.errorAllowanceCount = false;
    this.customerDuesDetails = [];
    this.allowanceDataList = [];
    this.lateLeinList = [];
  }

  async PayTerminatedpropertyProtection() {
    if (this.AutoEnrolExpiredInsWithNoCharge) {
      this.autoEnrolmentfornopayment = true;
    } else {
      this.autoEnrolmentAutoEnrollPPPartialPayment = true;
    }
    this.isShowAutoEnrolledPopuUp = false
    this.isShowAutoEnrolledPopuUp=false
    this.generalService.emitoAutEnrollPP = this.autoEnrolmentAutoEnrollPPPartialPayment;
    this.generalService.emitAutoEnrolwithNoDue = this.autoEnrolmentfornopayment;
    this.insuranceDetails = this.customerDuesDetails.AutoEnrolInsuranceSchemeModel;
    this.terminatedinsurencedue = this.customerDuesDetails.TotalInsuranceDue;
    this.terminatedInsuranceTaxDue=this.customerDuesDetails.TotalInsuranceTax;
    this.chargesObjForPayment = this.createPrePaymentObj(this.paymentPrePaidPeriod);
    this.chargesObjForPayment = JSON.parse(JSON.stringify(this.chargesObjForPayment));
    await this.getCustomerPrePayAmt(this.chargesObjForPayment);
    this.CustomerPropertyProtectionList.forEach((x) => {
      if (x.Id == this.customerDuesDetails.AutoEnrolInsuranceSchemeModel.Id) {
        x.SelectedInsurance = true;
      }
    })
  }

  async CancelAutoEnrollPP() {
    this.insuranceDetails = null;
    this.show_PartialPaymentPopup = false;
    this.chargesObjForPayment = this.createPrePaymentObj(this.paymentPrePaidPeriod);
    this.chargesObjForPayment = JSON.parse(JSON.stringify(this.chargesObjForPayment));
    this.customerDuesDetails.TotalInsuranceDue = this.terminatedinsurencedue;
    this.customerDuesDetails.TotalInsuranceTax = this.terminatedInsuranceTaxDue;
    if (!this.payTillLastPeriod) {
      await this.getCustomerPrePayAmt(this.chargesObjForPayment);
    }
    this.editPaymentDistribution();
    this.generalService.emitoAutEnrollPP = false;
    this.autoEnrolmentAutoEnrollPPPartialPayment = false;
    if (this.payTillLastPeriod) {
      this.getCustomerPaymentDues(this.unitDetail.LeaseNo, this.unitDetail.FacilityID, this.unitDetail.UnitId);
    }
    else if (this.isfromMakePayment) {
      if(this.isSaveAllowance){
        this.validateSaveAllowance();
      }else{
        this.makePayNow(1);
      }
      
    } else {
      this.addUnitToCart()
    }

  }

  async CancelAutoEnrollPPWithNoDue() {
    this.insuranceDetails = null;
    this.show_zeroPaymentPopup = false;
    this.autoEnrolmentfornopayment = false;
    this.generalService.emitAutoEnrolwithNoDue = false;
    this.chargesObjForPayment = this.createPrePaymentObj(this.paymentPrePaidPeriod);
    this.chargesObjForPayment = JSON.parse(JSON.stringify(this.chargesObjForPayment));
    this.customerDuesDetails.TotalInsuranceDue = this.terminatedinsurencedue;
    this.customerDuesDetails.TotalInsuranceTax = this.terminatedInsuranceTaxDue;
    if (!this.payTillLastPeriod) {
      await this.getCustomerPrePayAmt(this.chargesObjForPayment);
    }
    if (this.payTillLastPeriod) {
      this.getCustomerPaymentDues(this.unitDetail.LeaseNo, this.unitDetail.FacilityID, this.unitDetail.UnitId);
    }
    else if (this.isfromMakePayment) {
      if(this.isSaveAllowance){
        this.validateSaveAllowance();
      }else{
        this.makePayNow(1);
      }
      
    } else {
      this.addUnitToCart()
    }
  }
  ContinueWithAutoEnrollPP() {
    this.payTillLastPeriod = false;
    this.editPaymentDistribution();
    this.propProtPDPost = this.propProtPD;
    this.IsPaymentDist = true;
  this.currencyInputChanged(this.propProtPD, 'propProtPD')
    this.show_PartialPaymentPopup = false;
    this.show_zeroPaymentPopup = false;
  }
  OnClosePartialPaymentPopUp() {
    this.payTillLastPeriod = false;
    this.editPaymentDistribution();
    this.propProtPDPost = this.propProtPD;
    this.IsPaymentDist = true;
    this.currencyInputChanged(this.propProtPD, 'propProtPD')
    this.show_PartialPaymentPopup = false;
    this.show_zeroPaymentPopup = false;
  }
}
